import React, { createContext, useContext, useEffect, useState } from "react";

const STRINGS = {
  it: {
    nav: { login: "Accedi", register: "Registrati", dashboard: "Dashboard", admin: "SA", logout: "Esci", pricing: "Prezzi", features: "Funzioni", howItWorks: "Come funziona", myOrders: "I miei ordini" },
    landing: {
      tag: "by Renova 360",
      heroTitle1: "Il tuo ristorante.",
      heroTitle2: "I tuoi ordini.",
      heroAccent: "Zero marketplace.",
      heroSub: "Costruisci la pagina di delivery del tuo ristorante in 5 minuti. I tuoi clienti ordinano e pagano direttamente a te. 3 giorni gratis, poi 4,60€/mese.",
      cta: "Inizia 3 giorni gratis",
      ctaSecondary: "Vedi i prezzi",
      bullet1: "Pagamenti diretti via Stripe",
      bullet2: "Solo 6% di commissione",
      bullet3: "Nessun ristorante concorrente",
      featuresTitle: "Tutto quello che serve per il delivery",
      f1Title: "Menu personalizzato",
      f1Desc: "Carica piatti, foto, prezzi, categorie. Promo automatiche.",
      f2Title: "Brand al 100%",
      f2Desc: "Logo, banner, colori. Il tuo link da incorporare ovunque.",
      f3Title: "Mancia e urgenza",
      f3Desc: "Mancia opzionale per il rider e consegna prioritaria a sovrapprezzo.",
      f4Title: "Pagamento diretto",
      f4Desc: "I clienti pagano a te tramite Stripe. Renova trattiene solo il 6%.",
      pricingTitle: "Un piano per ogni cucina",
      pricingSub: "Tre giorni di prova gratuita. Annulla quando vuoi.",
      trial: "3 GIORNI GRATIS",
      basicTitle: "Basic",
      basicPrice: "4,60€",
      basicPer: "/mese",
      basicDesc: "Per chi inizia",
      proTitle: "Pro",
      proPrice: "9,90€",
      proPer: "/mese",
      proDesc: "Per chi cresce",
      extraInfo: "+3,00€/mese per ogni ristorante aggiuntivo",
      commissionInfo: "Commissione Renova: 6% sugli ordini",
      basicFeat1: "1 ristorante",
      basicFeat2: "Menu illimitato",
      basicFeat3: "Pagina personalizzabile",
      basicFeat4: "Stripe Connect",
      proFeat1: "Tutto del Basic",
      proFeat2: "Promo avanzate",
      proFeat3: "Mancia + Urgenza",
      proFeat4: "Statistiche e ordini illimitati",
      ctaPlan: "Inizia gratis",
      howTitle: "Tre passi per partire",
      step1: "Registrati con P.IVA",
      step1Desc: "Crea il tuo account in 60 secondi.",
      step2: "Personalizza la pagina",
      step2Desc: "Aggiungi logo, menu, orari, mancia, urgenza.",
      step3: "Condividi il link",
      step3Desc: "Sul sito, social, QR sui tavoli. I clienti pagano direttamente a te.",
      footer: "© 2026 FoodGo — by Renova 360. Tutti i diritti riservati.",
      saLink: "SA"
    },
    footer: {
      tagline: "La piattaforma di delivery white-label per ristoratori indipendenti. Tu vendi, noi scompariamo dietro le quinte.",
      legalTitle: "Legale",
      companyTitle: "Azienda",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      terms: "Termini & Condizioni"
    },
    cookies: {
      bannerTitle: "Cookie & Privacy",
      bannerText: "Usiamo cookie tecnici essenziali e, previo tuo consenso, cookie di analisi per migliorare il servizio. Puoi cambiare idea in qualsiasi momento.",
      privacyLink: "Privacy",
      cookieLink: "Cookie Policy",
      acceptAll: "Accetta tutti",
      rejectAll: "Solo essenziali",
      customize: "Personalizza",
      savePrefs: "Salva preferenze",
      essentialLabel: "Essenziali (sempre attivi)",
      essentialDesc: "Necessari per autenticazione, sicurezza e funzionamento del sito.",
      analyticsLabel: "Analisi",
      analyticsDesc: "Statistiche aggregate per migliorare il prodotto. Nessuna profilazione.",
      marketingLabel: "Marketing",
      marketingDesc: "Annunci personalizzati e partner terzi (disattivati di default)."
    },
    legal: {
      lastUpdate: "Ultimo aggiornamento",
      contactTitle: "Titolare del trattamento",
      privacy: {
        tag: "PRIVACY POLICY",
        title: "Informativa sulla Privacy (GDPR)",
        sections: [
          { h: "1. Titolare del trattamento", p: ["Il titolare del trattamento dei dati personali è Makai, P.IVA 09936410969, contattabile all'indirizzo email renova360@renova360.it."] },
          { h: "2. Dati raccolti", p: ["Raccogliamo i seguenti dati personali:"], list: ["Dati di registrazione ristoratore: nome, email, ragione sociale, P.IVA, indirizzo, telefono.", "Dati cliente al checkout: nome, telefono, indirizzo di consegna, email (fornita da Google OAuth se usata).", "Dati di pagamento gestiti direttamente da Stripe (non li conserviamo).", "Dati di navigazione: cookie tecnici e — solo con consenso — cookie analitici aggregati."] },
          { h: "3. Finalità", p: ["I dati vengono trattati per: (a) erogare il servizio FoodGo; (b) emettere fatturazione e gestire l'abbonamento; (c) trasmettere gli ordini al ristoratore destinatario; (d) adempiere ad obblighi di legge fiscali e contabili; (e) — solo previo consenso — analisi di prodotto e comunicazioni di marketing."] },
          { h: "4. Base giuridica", p: ["Il trattamento è basato su: esecuzione del contratto (art. 6.1.b GDPR), obbligo legale (art. 6.1.c), legittimo interesse (art. 6.1.f) e — quando previsto — consenso esplicito (art. 6.1.a)."] },
          { h: "5. Conservazione", p: ["I dati di fatturazione sono conservati per 10 anni come previsto dalla normativa fiscale italiana. Gli account inattivi vengono cancellati dopo 24 mesi previa notifica."] },
          { h: "6. Diritti dell'interessato", p: ["Hai diritto di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità dei tuoi dati (artt. 15-22 GDPR). Puoi esercitare i tuoi diritti scrivendo a renova360@renova360.it."] },
          { h: "7. Trasferimento dati a terzi", p: ["I dati possono essere comunicati a: Stripe Inc. (pagamenti), Google (autenticazione OAuth cliente), provider cloud per hosting. Tutti aderiscono al GDPR o a clausole contrattuali standard."] },
          { h: "8. Reclamo", p: ["Hai diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it)."] }
        ]
      },
      cookies: {
        tag: "COOKIE POLICY",
        title: "Informativa Cookie",
        sections: [
          { h: "1. Cosa sono i cookie", p: ["I cookie sono piccoli file di testo memorizzati sul tuo dispositivo per consentire il funzionamento del sito e analizzare l'uso del servizio."] },
          { h: "2. Cookie tecnici (sempre attivi)", p: ["Utilizziamo localStorage e sessionStorage per: mantenere la sessione di login (token JWT), salvare la lingua scelta, ricordare il carrello del cliente. Senza questi il sito non funziona."] },
          { h: "3. Cookie analitici", p: ["Solo previo consenso utilizziamo strumenti di analisi anonima del traffico per migliorare il prodotto. Nessuna profilazione individuale."] },
          { h: "4. Cookie di marketing", p: ["Disattivati di default. Verranno utilizzati solo con tuo esplicito consenso."] },
          { h: "5. Gestione del consenso", p: ["Puoi modificare le tue preferenze in qualunque momento cancellando il cookie 'foodgo_cookie_consent_v1' dal browser, oppure usando il banner che ricompare automaticamente."] }
        ]
      },
      terms: {
        tag: "TERMINI",
        title: "Termini e Condizioni del servizio",
        sections: [
          { h: "1. Oggetto", p: ["Il presente contratto disciplina l'uso della piattaforma FoodGo by Renova 360 (\"FoodGo\"), un prodotto Makai, P.IVA 09936410969."] },
          { h: "2. Prova gratuita e abbonamento", p: ["Ogni nuovo ristoratore beneficia di 3 (tre) giorni di prova gratuita. Al termine della prova, per continuare a utilizzare il servizio è necessario attivare un piano (Basic 4,60€/mese o Pro 9,90€/mese). Eventuali ristoranti aggiuntivi: 3,00€/mese cad."] },
          { h: "3. Commissione sugli ordini", p: ["Su ogni ordine pagato dal cliente finale, Renova trattiene una commissione pari al 6% del totale. Il restante 94% viene accreditato al ristoratore."] },
          { h: "4. Obblighi del ristoratore", p: ["Il ristoratore garantisce: validità della P.IVA fornita, conformità delle informazioni di prodotto e dei prezzi, gestione corretta degli ordini, conformità alle normative HACCP e di sicurezza alimentare."] },
          { h: "5. Recesso", p: ["L'abbonamento è mensile e può essere disdetto in qualsiasi momento; le somme già pagate per il mese in corso non sono rimborsabili."] },
          { h: "6. Limitazione di responsabilità", p: ["FoodGo è un intermediario tecnologico: la responsabilità sulla preparazione, qualità e consegna dei prodotti è esclusivamente del ristoratore."] },
          { h: "7. Foro competente", p: ["Per qualsiasi controversia è competente in via esclusiva il Foro di Roma."] }
        ]
      }
    },
    auth: {
      registerTitle: "Crea il tuo account",
      registerSub: "3 giorni di prova gratuita. Nessuna carta richiesta.",
      loginTitle: "Bentornato",
      loginSub: "Accedi al tuo account ristoratore",
      saTitle: "Renova 360 — Super Admin",
      saSub: "Area riservata Renova",
      email: "Email",
      password: "Password",
      fullName: "Nome e cognome",
      businessName: "Ragione sociale",
      vat: "P.IVA / VAT",
      address: "Indirizzo esatto",
      phone: "Telefono",
      submitRegister: "Crea account",
      submitLogin: "Accedi",
      submitSa: "Entra come Super Admin",
      hasAccount: "Hai già un account?",
      noAccount: "Non hai un account?",
      loginCta: "Accedi",
      registerCta: "Registrati",
      back: "Torna alla home",
      acceptTerms: "Accetto i Termini & Condizioni e ho letto la Privacy Policy",
      termsRequired: "Devi accettare i Termini per creare l'account",
      errorGeneric: "Si è verificato un errore. Riprova.",
      processing: "Attendi...",
      forgotLink: "Password dimenticata?",
      forgotTitle: "Recupera password",
      forgotSub: "Inserisci la tua email. Ti invieremo un link per reimpostare la password.",
      forgotCta: "Invia link di recupero",
      forgotDoneTitle: "Controlla la tua email",
      forgotDoneSub: "Se l'indirizzo è registrato, riceverai un link per reimpostare la password. Il link scade in 30 minuti.",
      devLinkLabel: "Modalità sviluppo · link diretto",
      resetTitle: "Nuova password",
      resetSub: "Scegli una nuova password per il tuo account.",
      resetCta: "Aggiorna password",
      resetDoneTitle: "Password aggiornata!",
      resetDoneSub: "Ora puoi accedere con la nuova password.",
      missingToken: "Link non valido o scaduto. Richiedine uno nuovo.",
      newPassword: "Nuova password",
      confirmPassword: "Conferma password",
      passwordTooShort: "La password deve avere almeno 6 caratteri",
      passwordsDontMatch: "Le password non coincidono"
    },
    gbp: {
      title: "Pubblica il link FoodGo su Google",
      subtitle: "Inserisci i dati del tuo profilo Google Business e pubblica il pulsante 'Ordina online' con il link FoodGo del tuo ristorante.",
      connect: "Collega Google Business",
      businessUrlLabel: "URL del tuo profilo Google Business",
      businessUrlPh: "Es. https://g.page/il-mio-ristorante o link Google Maps",
      businessUrlHint: "Apri Google Maps, cerca il tuo ristorante, clicca «Condividi» e copia il link.",
      placeIdLabel: "Place ID Google (opzionale, più preciso)",
      placeIdHint: "Trovi il Place ID su",
      urlToPublish: "Link da incollare su Google",
      copy: "Copia",
      fillFirst: "Compila almeno uno dei campi qui sopra per abilitare il pulsante.",
      linkCopied: "Link FoodGo copiato! Incollalo nel campo 'Ordina online' su Google.",
      linkCopyManual: "Apertura Google Business in corso. Copia manualmente il link mostrato sopra.",
      guideTitle: "Pubblica il link su Google Business",
      guideIntro: "Abbiamo aperto Google Business in una nuova scheda e copiato il link FoodGo negli appunti. Segui questi 3 passi:",
      guideStep1: "Sulla scheda Google Business appena aperta, clicca «Modifica profilo» (o «Edit profile»).",
      guideStep2: "Cerca la sezione «Ordini» (Orders) o «Link per ordinare» e incolla questo URL:",
      guideStep3: "Clicca «Salva» (o «Save»). Tra qualche minuto Google mostrerà il pulsante «Ordina online» sul tuo profilo.",
      copyAgain: "Ricopia link",
      guideDone: "Fatto",
    },
    guide: {
      kicker: "GUIDA RISTORATORE",
      heroTitle: "Tutto quello che ti serve, in un posto solo",
      heroIntro: "Da zero al primo ordine in pochi minuti. Sezioni dettagliate, FAQ pratiche e consigli per aumentare le vendite.",
      tocTitle: "Indice",
      tipsLabel: "Consigli",
      faqTitle: "Domande frequenti",
      quickstart: {
        kicker: "PARTI IN 5 MINUTI",
        title: "Avvio rapido",
        intro: "Segui questi 5 passi e ricevi il primo ordine oggi stesso.",
        steps: [
          { title: "Registrati e attiva la prova gratuita di 3 giorni", body: "Vai su /register, compila P.IVA, indirizzo e email. Entri subito nel pannello." },
          { title: "Crea il tuo ristorante", body: "Dal Dashboard clicca «Crea ristorante» e inserisci il nome. Otterrai automaticamente un link pubblico /r/tuo-slug." },
          { title: "Aggiungi i piatti (o importali da PDF)", body: "Nella tab «Menu» inserisci piatti uno alla volta oppure carica il PDF del tuo menu: l'AI lo analizza e crea i piatti per te." },
          { title: "Configura i pagamenti", body: "Tab «Pagamenti»: collega Stripe, PayPal.me o Satispay. Almeno uno deve essere attivo per ricevere ordini." },
          { title: "Condividi il link pubblico", body: "Copia il link nel tuo Dashboard e mettilo su sito, profilo Google Business, social, menù QR. È live 24/7." },
        ],
        tips: [
          "Imposta logo, colore primario e foto di copertina nella tab «Impostazioni» per dare personalità alla pagina.",
          "Attiva la fascia oraria di apertura: gli ordini vengono accettati solo quando il ristorante è aperto.",
        ],
      },
      register: {
        kicker: "ACCESSO",
        title: "Registrazione e accesso",
        intro: "Il tuo account ristoratore è separato da quello dei clienti. La prova è gratuita per 3 giorni.",
        steps: [
          { title: "Vai su /register", body: "Inserisci email, password (min 6 caratteri), nome attività, P.IVA, indirizzo. Riceverai un token JWT salvato nel browser." },
          { title: "Prova gratuita 3 giorni", body: "Stato «trial» con scadenza visibile in alto al Dashboard. Allo scadere puoi attivare Basic 4.60€/mese o Pro 9.90€/mese." },
          { title: "Login successivi", body: "Vai su /login, stessa email e password. Per reset password contatta info@renova360.it." },
          { title: "Logout", body: "Clicca l'icona di uscita nella barra in alto. Il token viene rimosso dal browser." },
        ],
      },
      subscription: {
        kicker: "PAGAMENTI",
        title: "Abbonamento Basic / Pro / Extra",
        intro: "I piani sono mensili e si gestiscono direttamente dalla tab «Abbonamento».",
        steps: [
          { title: "Basic — 4.60€/mese", body: "1 ristorante, menu illimitato, ordini illimitati, pagamento con carta/Satispay/PayPal/cassa." },
          { title: "Pro — 9.90€/mese", body: "Tutto di Basic + funzionalità avanzate (loyalty point, analytics, AI menu import)." },
          { title: "Ristorante extra — +3.00€/mese", body: "Se gestisci più sedi con la stessa anagrafica, aggiungi un ristorante extra dal Dashboard." },
          { title: "Commissione Renova 6%", body: "Renova trattiene il 6% solo sugli ordini eseguiti, NON sull'abbonamento. Su Stripe Connect viene scalata automaticamente; su Satispay/PayPal/cash viene accumulata e devi saldarla quando raggiungi la soglia (default 50€)." },
        ],
        tips: [
          "Puoi cambiare piano in qualsiasi momento dal pulsante «Cambia piano».",
          "Se il tuo abbonamento scade il ristorante viene messo in pausa (non cancellato).",
        ],
      },
      menu: {
        kicker: "MENU",
        title: "Gestione del menu",
        intro: "Carica i piatti manualmente o, in pochi secondi, dall'import AI di un PDF.",
        steps: [
          { title: "Aggiungi un piatto", body: "Tab «Menu» → compila nome, descrizione, prezzo, categoria, allergeni. Carica una foto (drag&drop)." },
          { title: "Modifica / elimina", body: "Clicca l'icona ✏️ per modificare. Cestino per cancellare. Le modifiche sono live immediatamente." },
          { title: "Import da PDF (AI)", body: "Carica il PDF del tuo menù: l'AI estrae nomi, prezzi, descrizioni in italiano/inglese e crea i piatti. Dopo puoi correggere/aggiungere foto." },
          { title: "Allergeni", body: "Spunta i 14 allergeni standard EU per ogni piatto: appaiono come chip colorati ai clienti." },
        ],
        tips: [
          "Foto reali dei tuoi piatti convertono il 40% in più rispetto a foto stock.",
          "Una descrizione di 1-2 righe aumenta le vendite del singolo piatto.",
        ],
      },
      orders: {
        kicker: "ORDINI",
        title: "Gestione ordini in tempo reale",
        intro: "Ricevi gli ordini nella tab «Ordini»: pagati, ritiro/consegna, contatto cliente, totale.",
        steps: [
          { title: "Accetta l'ordine", body: "Clicca «Accetta» indicando il tempo stimato di preparazione (in minuti). Il cliente riceve l'orario di arrivo." },
          { title: "Rifiuta (rara)", body: "Se proprio non puoi gestirlo (es. ingrediente finito), clicca «Rifiuta». Stripe rimborsa automaticamente; cash/Satispay/PayPal non ti devono nulla." },
          { title: "Avanza lo stato", body: "Sequenza: Pagato → Accettato → In preparazione → Pronto/In consegna → Consegnato. Il cliente vede gli aggiornamenti dal tracking." },
          { title: "Conferma incasso cash/PayPal/Satispay", body: "Quando ricevi il pagamento manuale clicca «✓ Pagato in contanti/PayPal/Satispay». Sposta l'ordine in stato «paid» e le commissioni vengono accumulate." },
        ],
        tips: [
          "Lasciare un ordine «paid» senza accettarlo per più di 5 minuti rovina la customer experience: imposta una notifica audio.",
          "Per gli ordini di consegna, dopo «Pronto» passa a «In consegna» quando il rider esce.",
        ],
      },
      payments: {
        kicker: "INCASSI",
        title: "Metodi di pagamento",
        intro: "I clienti pagano direttamente te (non Renova). Renova trattiene solo il 6% di commissione.",
        steps: [
          { title: "Stripe Connect (carta)", body: "Tab «Pagamenti» → «Connetti Stripe». Onboarding diretto su Stripe (richiede P.IVA + IBAN). Incassi sul tuo conto bancario in 2-7 giorni. La commissione Renova viene scalata automaticamente sull'ordine." },
          { title: "Satispay", body: "Inserisci il tuo «codice attivazione Satispay» (lo trovi nell'app Business Satispay). Il cliente riceve un QR Code dinamico sul tracking ordine. Conferma manualmente quando ricevi il pagamento." },
          { title: "PayPal.me", body: "Inserisci il tuo handle PayPal.me (es. mioristorante). Il cliente clicca e paga sulla tua pagina PayPal. Conferma incasso dal Dashboard." },
          { title: "Pagamento al ritiro (contanti)", body: "Disponibile SOLO per ordini di ritiro in negozio. Il cliente paga al banco quando arriva. Conferma incasso dal Dashboard." },
        ],
        tips: [
          "Attiva almeno Stripe + un metodo alternativo (Satispay o PayPal) per non perdere conversioni.",
          "Per Stripe Connect, completa il KYC entro 7 giorni o non potrai ricevere bonifici.",
        ],
      },
      pickup: {
        kicker: "ORDINI",
        title: "Ritiro vs. Consegna",
        intro: "Il cliente sceglie tra «Consegna» (con indirizzo) e «Ritiro» (senza indirizzo, paga al banco).",
        steps: [
          { title: "Consegna", body: "Il cliente inserisce indirizzo. Tu addebiti la delivery_fee impostata. Solo pagamento digitale (Stripe/Satispay/PayPal)." },
          { title: "Ritiro", body: "Niente indirizzo, niente delivery_fee. Il cliente sceglie tra pagamento digitale o «Paga al ritiro» (contanti al banco)." },
          { title: "Tempo stimato", body: "Quando accetti l'ordine indichi il tempo (es. 25 min). Il cliente vede l'orario esatto di pronto/consegna sul tracking." },
        ],
      },
      loyalty: {
        kicker: "FIDELIZZAZIONE",
        title: "Programma punti fedeltà",
        intro: "Premia i clienti che tornano. I punti si accumulano automaticamente su ogni ordine pagato.",
        steps: [
          { title: "Attiva il programma", body: "Tab «Impostazioni» → sezione Loyalty → «Abilita programma fedeltà»." },
          { title: "Imposta il rapporto", body: "Es: 1 punto ogni 1€ speso. Valore di riscatto: 0.05€ per punto (1 punto = 5 centesimi di sconto)." },
          { title: "Soglia minima riscatto", body: "Imposta il minimo di punti per poter usare lo sconto (default 20). Evita che il cliente riscatti 1€ per volta." },
          { title: "Cliente paga e accumula", body: "Quando un ordine arriva a stato «paid» i punti vengono accreditati al cliente. Su /storefront vede il saldo e può convertirli in sconto al checkout." },
        ],
        tips: [
          "Comunica chiaramente la regola: «1€ = 1 punto. 20 punti = 1€ di sconto».",
          "Un programma fedeltà ben tarato aumenta la frequenza di ordine del 25-40%.",
        ],
      },
      google: {
        kicker: "MARKETING",
        title: "Collega il link su Google Business",
        intro: "Aggiungi il pulsante «Ordina online» / «Prenota» al tuo profilo Google Business per intercettare ricerche su Maps e Search.",
        steps: [
          { title: "Trova il tuo profilo Google Business", body: "Cerca il tuo ristorante su Google Maps. Deve apparire la scheda con foto, orari e recensioni. Se non c'è, creala gratis su business.google.com." },
          { title: "Apri la card «Pubblica il link FoodGo su Google»", body: "È nel Dashboard, subito sotto il tuo link pubblico." },
          { title: "Inserisci URL profilo (e/o Place ID)", body: "Copia il link Google Maps del tuo ristorante. Place ID è opzionale ma più preciso (lo trovi sul Google Place ID Finder)." },
          { title: "Clicca «Collega Google Business»", body: "FoodGo copia automaticamente il tuo link ordini negli appunti e apre Google Business in una nuova scheda. Segui la guida 3-step in overlay per incollarlo." },
        ],
        tips: [
          "Aggiorna anche il sito web e le immagini su Google Business: pagine complete ricevono 7x più ordini.",
          "Il pulsante «Ordina online» appare su Google entro 24-48 ore.",
        ],
      },
      commissions: {
        kicker: "RENOVA · 6%",
        title: "Commissioni Renova e auto-sospensione",
        intro: "Renova trattiene il 6% su ogni ordine pagato. Su Stripe è automatico, sugli altri si accumula come debito.",
        steps: [
          { title: "Ordini con carta (Stripe)", body: "La commissione viene scalata automaticamente al momento del pagamento. Niente da fare." },
          { title: "Ordini Satispay/PayPal/Cassa", body: "La commissione si accumula come «debito». Lo vedi nel banner in alto al Dashboard." },
          { title: "Salda quando vuoi", body: "Clicca «Paga subito» nel banner commissioni. Pagamento con carta al volo, ricevuta inclusa." },
          { title: "Soglia di auto-sospensione", body: "Se il debito supera la soglia (default 50€) il ristorante viene messo automaticamente in pausa: nessun nuovo ordine può arrivare. Riattivazione automatica appena saldi." },
        ],
        tips: [
          "Tieni il debito sotto la soglia: salda settimanalmente per evitare interruzioni.",
          "La soglia può essere modificata dal Super Admin Renova se hai accordi speciali.",
        ],
      },
      faq: [
        { q: "Quanto costa FoodGo?", a: "4.60€/mese piano Basic, 9.90€/mese piano Pro. Più 6% di commissione SOLO sugli ordini ricevuti. Nessun costo di setup, nessun vincolo." },
        { q: "Posso usarlo gratis?", a: "Sì, hai 3 giorni di prova gratuita. Dopo, devi attivare un piano per continuare a ricevere ordini." },
        { q: "Quando ricevo i soldi degli ordini?", a: "Con Stripe in 2-7 giorni sul tuo conto bancario. Con Satispay/PayPal istantaneo. In cassa li ricevi al ritiro." },
        { q: "Renova prende soldi dal mio conto?", a: "No mai. Stripe ti accredita direttamente; Renova fattura mensilmente l'abbonamento e tu paghi la commissione 6% al raggiungimento della soglia, NON è un addebito automatico." },
        { q: "Cosa succede se rifiuto un ordine?", a: "Stripe rimborsa automaticamente il cliente; Satispay/PayPal/cassa non hai mai ricevuto soldi quindi nulla da rimborsare. Il cliente è notificato." },
        { q: "Posso vendere alcolici?", a: "Sì, fintanto che rispetti le leggi locali (es. divieto di vendita ai minori). FoodGo è una piattaforma neutrale: la responsabilità legale è del ristoratore." },
        { q: "Posso cancellare il mio account?", a: "Sì, contatta info@renova360.it. Cancellazione entro 24 ore, ti restituiamo eventuale rateo non utilizzato." },
        { q: "I clienti hanno bisogno di un account?", a: "Sì, fanno login con Google al checkout (un click). Questo serve per tracciare il punteggio fedeltà e proteggerti da frodi." },
        { q: "Posso esportare i miei dati?", a: "Sì, dalla tab «Impostazioni» → «Esporta dati» (CSV ordini, menu, clienti). I tuoi dati sono tuoi, sempre." },
        { q: "Funziona da cellulare?", a: "Sì, sia per te (dashboard mobile) sia per i clienti (sito mobile-first responsive). Nessuna app da installare." },
      ],
    },
    billing: {
      kicker: "DATI DI FATTURAZIONE",
      title: "Dati per la fatturazione",
      subtitle: "Obbligatori per attivare l'abbonamento. Servono a Renova per emettere le fatture mensili.",
      companyLabel: "Ragione sociale / Nome e cognome *",
      vatLabel: "P.IVA / Codice Fiscale *",
      addressLabel: "Indirizzo *",
      emailLabel: "Email fatturazione *",
      pecLabel: "PEC o Codice SDI (0000000 se assenti) *",
      phoneLabel: "Telefono *",
      save: "Salva dati fatturazione",
      cancel: "Annulla",
      edit: "Modifica",
      savedOk: "Dati di fatturazione salvati.",
      requiredBeforeCheckout: "Compila i dati di fatturazione prima di attivare l'abbonamento.",
    },
    dashboard: {
      title: "Dashboard ristoratore",
      welcome: "Ciao",
      noRestaurants: "Non hai ancora ristoranti. Creane uno per iniziare.",
      create: "Crea ristorante",
      orders: "Ordini",
      menu: "Menu",
      settings: "Impostazioni",
      payments: "Pagamenti",
      subscription: "Abbonamento",
      guide: "📖 Istruzioni",
      yourLink: "Il tuo link pubblico",
      copyLink: "Copia link",
      copied: "Copiato!",
      addDish: "Aggiungi piatto",
      dishName: "Nome piatto",
      dishDesc: "Descrizione",
      dishPrice: "Prezzo €",
      dishImage: "URL immagine",
      dishCategory: "Categoria",
      save: "Salva",
      delete: "Elimina",
      noDishes: "Nessun piatto. Aggiungi il primo!",
      generalInfo: "Informazioni generali",
      name: "Nome ristorante",
      description: "Descrizione",
      address: "Indirizzo",
      phone: "Telefono",
      logoUrl: "URL logo",
      coverUrl: "URL banner di copertina",
      primaryColor: "Colore primario",
      hours: "Orari di apertura",
      deliveryTime: "Tempo consegna stimato (min)",
      deliveryFee: "Costo di consegna €",
      tipToggle: "Mancia rider opzionale",
      urgencyToggle: "Consegna prioritaria",
      urgencyFee: "Costo consegna prioritaria €",
      urgencyLabel: "Etichetta urgenza",
      promoMessage: "Messaggio promo",
      promoDiscount: "Sconto promo %",
      stripeAccountId: "ID Stripe Connect (acct_...)",
      paypalEmail: "Email PayPal",
      satispayHandle: "Satispay (telefono o handle)",
      paypalMe: "PayPal.Me (username, opzionale - genera QR)",
      customerNotes: "Note del cliente",
      pointsAwarded: "Punti per questo ordine",
      customerPoints: "Punti cliente totali",
      markPaidPaypal: "Pagato via PayPal",
      markPaidSatispay: "Pagato via Satispay",
      confirmMarkPaid: "Confermi di aver ricevuto il pagamento per questo ordine?",
      paymentSettings: "Impostazioni pagamenti",
      paymentInfo: "Inserisci il tuo Stripe Connect: i clienti pagheranno direttamente a te (Renova trattiene il 6%).",
      saved: "Salvato",
      ordersTitle: "I tuoi ordini",
      noOrders: "Nessun ordine ancora.",
      status: "Stato",
      total: "Totale",
      customer: "Cliente",
      subscriptionTitle: "Abbonamento",
      planBasic: "Basic 4,60€/mese",
      planPro: "Pro 9,90€/mese",
      extraRest: "Ristoranti aggiuntivi",
      activate: "Attiva abbonamento",
      active: "Attivo",
      trial: "PROVA",
      inactive: "Inattivo",
      until: "Valido fino al",
      newRestName: "Nome del nuovo ristorante",
      preview: "Vedi pagina",
      trialBannerTitle: "Sei in prova gratuita",
      trialBannerSub: "Ti restano {d} giorni. Attiva un piano per non interrompere il servizio.",
      trialExpired: "Prova scaduta — attiva un piano per continuare",
      mark: { pending: "In attesa", paid: "Pagato", accepted: "Accettato", preparing: "In preparazione", ready: "Pronto al ritiro", out_for_delivery: "In consegna", delivered: "Consegnato", cancelled: "Annullato", rejected: "Rifiutato" },
      accept: "Accetta",
      reject: "Rifiuta",
      markPreparing: "In preparazione",
      markReady: "Pronto al ritiro",
      markOut: "Partito",
      updateEta: "Aggiorna ETA",
      updateTime: "Aggiorna Time",
      deliverTo: "Consegnare a",
      pickupInStore: "Ritiro in negozio",
      statusOpen: "Ristorante APERTO",
      statusClosed: "Ristorante CHIUSO",
      openHint: "Stai accettando ordini dai clienti.",
      closedHint: "Nessun ordine può essere effettuato dai clienti.",
      openRestaurant: "Apri ristorante",
      closeRestaurant: "Chiudi ristorante",
      deleteRestaurant: "Cancella ristorante",
      deleteConfirmTitle: "Cancellare il ristorante?",
      deleteConfirmBody: "Questa operazione cancellerà definitivamente IL RISTORANTE, tutti i PIATTI, gli ORDINI e le TRANSAZIONI. L'operazione è IRREVERSIBILE.",
      deleteConfirmTypeHint: "Per confermare, digita il nome del ristorante",
      deleteYes: "Sì, cancella definitivamente",
      weeklyHours: "Orari settimanali",
      weeklyHoursHint: "Fuori orario, il sistema rifiuta automaticamente gli ordini. Lascia tutto spento per essere sempre aperto.",
      dayNames: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
      copyMonToAll: "Copia Lun → tutti",
      clearAll: "Svuota tutti",
      addSlot: "Aggiungi fascia",
      closedDay: "Chiuso",
      loyalty: {
        title: "Punti fedeltà",
        hint: "Il cliente accumula punti su ogni ordine pagato e può scontarli al checkout.",
        on: "Attivo",
        off: "Spento",
        pointsPerEuro: "Punti per ogni 1 €",
        euroPerPoint: "€ per ogni 1 punto",
        minRedeem: "Min. punti per riscatto",
        preview: "Anteprima: {ppe} pt ogni 1 € speso · {ept} € di sconto per ogni punto",
      },
      commission: {
        title: "Commissioni da saldare",
        hint: "Pagamento automatico al raggiungimento di € 50. Puoi anche pagare subito in qualsiasi momento.",
        dueHint: "Hai superato la soglia di 50€: salda ora le commissioni dovute a Renova.",
        orders: "ordini in contanti",
        payNow: "Paga subito",
      },
      waitingCustomer: "In attesa conferma cliente",
      refundManual: "rimborso manuale",
      edit: "Modifica",
      editDish: "Modifica piatto",
      cancel: "Annulla",
      dishIngredients: "Ingredienti",
      dishAllergens: "Allergeni",
      menuImportTitle: "Importa menu PDF",
      menuImportSub: "Carica un PDF del tuo menu: l'AI riconosce nome, descrizione, ingredienti e allergeni.",
      menuPickPdf: "Scegli PDF",
      dishesFound: "piatti trovati",
      menuImportConfirm: "Aggiungi tutti",
      menuImportEmpty: "Nessun piatto riconosciuto. Riprova con un PDF più chiaro.",
      uploadingPdf: "Caricamento PDF",
      aiProcessing: "AI in lavorazione",
      savingDishes: "Salvataggio piatti",
      aiHint: "Gemini sta analizzando il PDF, può richiedere 10-20s",
      extraGraceTitle: "Ristorante in periodo di prova extra",
      extraGraceSub: "Hai {d} giorni per pagare 3,00€/mese, altrimenti questo ristorante verrà bloccato (non eliminato).",
      extraExpiredTitle: "Ristorante bloccato",
      extraExpiredSub: "Il periodo di grazia di 3 giorni è scaduto. Paga 3,00€ per riattivarlo.",
      payExtraNow: "Paga 3,00€ ora",
      extraGraceBadge: "PROVA EXTRA",
      extraBlockedBadge: "BLOCCATO",
      extraPaidBadge: "EXTRA OK",
      extraPaidUntil: "Pagato fino al",
      extraCreatedToastTitle: "Ristorante creato!",
      extraCreatedToastSub: "Hai 3 giorni di prova. Poi 3,00€/mese per mantenerlo attivo.",
      lockedManually: "Bloccato dall'amministratore",
      lockedOwnerSub: "Abbonamento principale scaduto",
      renewalSoonTitle: "Abbonamento in scadenza",
      renewalSoonSub: "Scade tra {d} giorni. Rinnova ora per evitare interruzioni del servizio.",
      renew: "Rinnova ora",
      connectTitle: "Stripe Connect",
      connectSub: "Connetti il tuo account Stripe per ricevere i pagamenti dei clienti direttamente (Renova trattiene il 6%).",
      connectBtn: "Connetti con Stripe",
      connectContinue: "Completa configurazione",
      connectConnected: "Connesso",
      connectDisabledDemo: "Disponibile solo in produzione con chiave Stripe reale.",
      connectCharges: "Pagamenti",
      connectPayouts: "Bonifici",
      analyticsTitle: "Analytics ultimi {d} giorni",
      gmv: "GMV",
      commission: "Commissione 6%",
      ordersCount: "Ordini",
      topRestaurants: "Top ristoranti"
    },
    storefront: {
      menu: "Menu",
      cart: "Carrello",
      empty: "Il carrello è vuoto",
      add: "Aggiungi",
      remove: "Rimuovi",
      subtotal: "Subtotale",
      loyaltyTitle: "I tuoi punti",
      loyaltyDiscount: "Sconto punti",
      loyaltyMinHint: "Minimo {n} punti per riscattare",
      loyaltyNeedMore: "Servono almeno {n} punti per riscattare. Te ne mancano {x}.",
      pointsLabel: "Punti",
      pointsShort: "pt",
      myOrdersLink: "I miei ordini",
      googleSignup: "Iscriviti con Google",
      tip: "Mancia rider",
      tipHelp: "Lascia una mancia al rider (opzionale)",
      urgency: "Consegna prioritaria",
      delivery: "Consegna",
      pickup: "Ritiro",
      pickupAt: "Ritira presso",
      payOnDelivery: "Paga alla consegna",
      payOnPickup: "Paga al ritiro",
      payOnArrivalHint: "Pagherai direttamente al ristoratore in contanti.",
      choosePayment: "Scegli come pagare",
      payNowStripe: "Paga con carta (Stripe)",
      notesLabel: "Note ordine (allergie, preferenze)",
      notesPlaceholder: "Es. no pomodoro, allergico ai latticini, ben cotto...",
      methodInactive: "Metodo non attivo da parte del ristoratore",
      activeOrderTag: "Ordine in corso",
      activeOrdersCount: "{n} ordini in corso",
      openBadge: "Aperto",
      closedBadge: "Chiuso",
      outsideHours: "Fuori orario",
      closedNoOrders: "Ristorante chiuso",
      outsideHoursNoOrders: "Fuori orario di apertura",
      trackOrder: "Traccia ordine",
      cashPayment: "PAGAMENTO ALL'ARRIVO",
      discount: "Sconto",
      total: "Totale",
      checkout: "Procedi al pagamento",
      yourInfo: "I tuoi dati",
      loginRequired: "Accedi con Google per ordinare",
      loginRequiredSub: "Ti chiediamo di accedere per inviare l'ordine in sicurezza.",
      loginGoogle: "Continua con Google",
      name: "Nome",
      phone: "Telefono",
      address: "Indirizzo di consegna",
      notes: "Note per il ristorante",
      payNow: "Paga ora",
      processing: "Elaborazione...",
      deliveryTime: "Consegna in ~{min} min",
      successTitle: "Pagamento ricevuto!",
      successDesc: "Grazie. Il ristorante ha ricevuto il tuo ordine.",
      backHome: "Torna al ristorante",
      promoBanner: "Promo attiva: -{p}%",
      loggedAs: "Ordini come",
      lockedTitle: "Ristorante temporaneamente non disponibile",
      lockedSub: "Questo ristorante è momentaneamente bloccato. Riprova più tardi."
    },
    admin: {
      title: "Renova 360 — Super Admin",
      kpiRestaurants: "Ristoranti attivi",
      kpiCommission: "Commissione Renova (6%)",
      kpiCommissionCollected: "Incassato",
      kpiCommissionToCollect: "Da incassare",
      kpiSubs: "Ricavi abbonamenti",
      kpiOrders: "Ordini pagati",
      kpiGmv: "GMV totale",
      kpiActiveSubs: "Account attivi",
      list: "Lista ristoranti",
      orders: "Ultimi ordini",
      block: "Blocca",
      unblock: "Sblocca",
      suspend: "Sospendi",
      unsuspend: "Riattiva",
      cancel: "Annulla",
      restore: "Ripristina",
      delete: "Cancella",
      suspended: "Sospeso",
      cancelled: "Annullato",
      suspendReasonPrompt: "Motivo della sospensione (opzionale):",
      deleteConfirmPrompt: "Per cancellare DEFINITIVAMENTE il ristorante {n} (e tutti i suoi dati: piatti, ordini, transazioni) digita CANCELLA",
      open: "Apri",
      accounting: "Contabilità",
      ledger: "Movimenti contabili",
      noLedger: "Nessun movimento",
      gmv: "GMV",
      commissionTotal: "Commissione 6%",
      commissionSettled: "Saldata",
      commissionPending: "Da saldare cash",
      subscriptions: "Abbonamenti",
      extraResto: "Extra rist.",
      revenueRenova: "Ricavi Renova",
      thresholdLabel: "Soglia €",
      debtSuspended: "Sospeso debito",
    },
    myOrders: {
      tag: "ORDINI CLIENTE",
      title: "I miei ordini",
      sub: "Traccia in tempo reale lo stato dei tuoi ordini.",
      empty: "Non hai ancora effettuato ordini.",
      loginPrompt: "Accedi con Google da un ristorante per iniziare.",
      back: "Indietro",
      backToRestaurant: "Torna al ristorante",
      confirmDelivered: "Conferma consegna",
      summary: "Riepilogo ordine",
      rejectedTitle: "Ordine rifiutato",
      refundManual: "Il ristoratore gestirà il rimborso manualmente in Stripe.",
      payInstructionsPaypal: "Completa il pagamento su PayPal",
      payInstructionsSatispay: "Completa il pagamento su Satispay",
      sendTo: "Invia",
      toEmail: "a",
      toHandle: "a",
      pendingNote: "Il ristoratore confermerà la ricezione e procederà con l'ordine.",
      amount: "Importo",
      openInApp: "Apri in app",
      pointsForOrder: "Punti per questo ordine",
      pointsTotal: "Totale punti",
      cashPay: "Cassa",
      itemSingular: "piatto",
      itemPlural: "piatti",
      refundStatus: "Stato rimborso"
    }
  },
  en: {
    nav: { login: "Login", register: "Sign up", dashboard: "Dashboard", admin: "SA", logout: "Logout", pricing: "Pricing", features: "Features", howItWorks: "How it works", myOrders: "My orders" },
    landing: {
      tag: "by Renova 360",
      heroTitle1: "Your restaurant.",
      heroTitle2: "Your orders.",
      heroAccent: "Zero marketplace.",
      heroSub: "Build your restaurant's delivery page in 5 minutes. Customers order and pay you directly. 3 days free, then €4.60/mo.",
      cta: "Start 3 days free",
      ctaSecondary: "See pricing",
      bullet1: "Direct payments via Stripe",
      bullet2: "Only 6% commission",
      bullet3: "Zero competitors on your page",
      featuresTitle: "Everything you need for delivery",
      f1Title: "Custom menu",
      f1Desc: "Upload dishes, photos, prices, categories. Auto promos.",
      f2Title: "100% your brand",
      f2Desc: "Logo, banner, colors. Your shareable link anywhere.",
      f3Title: "Tip and urgency",
      f3Desc: "Optional rider tip and priority delivery with extra cost.",
      f4Title: "Direct payment",
      f4Desc: "Customers pay you via Stripe. Renova only keeps 6%.",
      pricingTitle: "A plan for every kitchen",
      pricingSub: "Three days free trial. Cancel anytime.",
      trial: "3 DAYS FREE",
      basicTitle: "Basic",
      basicPrice: "€4.60",
      basicPer: "/mo",
      basicDesc: "To get started",
      proTitle: "Pro",
      proPrice: "€9.90",
      proPer: "/mo",
      proDesc: "To grow",
      extraInfo: "+€3.00/mo per additional restaurant",
      commissionInfo: "Renova commission: 6% on orders",
      basicFeat1: "1 restaurant",
      basicFeat2: "Unlimited menu",
      basicFeat3: "Custom page",
      basicFeat4: "Stripe Connect",
      proFeat1: "Everything in Basic",
      proFeat2: "Advanced promos",
      proFeat3: "Tip + Urgency",
      proFeat4: "Unlimited stats & orders",
      ctaPlan: "Start free",
      howTitle: "Three steps to go live",
      step1: "Sign up with VAT",
      step1Desc: "Create your account in 60 seconds.",
      step2: "Customize your page",
      step2Desc: "Add logo, menu, hours, tip, urgency.",
      step3: "Share the link",
      step3Desc: "Website, socials, table QR codes. Customers pay you directly.",
      footer: "© 2026 FoodGo — by Renova 360. All rights reserved.",
      saLink: "SA"
    },
    auth: {
      registerTitle: "Create your account",
      registerSub: "3 days free trial. No card required.",
      loginTitle: "Welcome back",
      loginSub: "Sign in to your restaurateur account",
      saTitle: "Renova 360 — Super Admin",
      saSub: "Reserved area for Renova",
      email: "Email",
      password: "Password",
      fullName: "Full name",
      businessName: "Business name",
      vat: "VAT number",
      address: "Exact address",
      phone: "Phone",
      submitRegister: "Create account",
      submitLogin: "Sign in",
      submitSa: "Enter as Super Admin",
      hasAccount: "Already have an account?",
      noAccount: "Don't have an account?",
      loginCta: "Sign in",
      registerCta: "Sign up",
      back: "Back to home",
      acceptTerms: "I accept the Terms & Conditions and I have read the Privacy Policy",
      termsRequired: "You must accept the Terms to create your account",
      errorGeneric: "Something went wrong. Please try again.",
      processing: "Please wait...",
      forgotLink: "Forgot password?",
      forgotTitle: "Recover password",
      forgotSub: "Enter your email. We'll send you a link to reset your password.",
      forgotCta: "Send recovery link",
      forgotDoneTitle: "Check your email",
      forgotDoneSub: "If the address is registered, you'll receive a reset link. It expires in 30 minutes.",
      devLinkLabel: "Development mode · direct link",
      resetTitle: "New password",
      resetSub: "Choose a new password for your account.",
      resetCta: "Update password",
      resetDoneTitle: "Password updated!",
      resetDoneSub: "You can now sign in with your new password.",
      missingToken: "Invalid or expired link. Request a new one.",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      passwordTooShort: "Password must be at least 6 characters",
      passwordsDontMatch: "Passwords don't match"
    },
    gbp: {
      title: "Publish your FoodGo link on Google",
      subtitle: "Enter your Google Business profile data and publish the 'Order online' button with your FoodGo restaurant link.",
      connect: "Connect Google Business",
      businessUrlLabel: "Your Google Business profile URL",
      businessUrlPh: "e.g. https://g.page/my-restaurant or Google Maps link",
      businessUrlHint: "Open Google Maps, search your restaurant, tap «Share» and copy the link.",
      placeIdLabel: "Google Place ID (optional, more accurate)",
      placeIdHint: "Find your Place ID on",
      urlToPublish: "Link to paste on Google",
      copy: "Copy",
      fillFirst: "Fill at least one field above to enable the button.",
      linkCopied: "FoodGo link copied! Paste it in Google's 'Order online' field.",
      linkCopyManual: "Opening Google Business. Copy the link shown above manually.",
      guideTitle: "Publish the link on Google Business",
      guideIntro: "We opened Google Business in a new tab and copied the FoodGo link to your clipboard. Follow these 3 steps:",
      guideStep1: "On the Google Business tab just opened, click «Edit profile».",
      guideStep2: "Find the «Orders» section or «Order link» and paste this URL:",
      guideStep3: "Click «Save». Within minutes Google will show the «Order online» button on your profile.",
      copyAgain: "Copy again",
      guideDone: "Done",
    },
    guide: {
      kicker: "RESTAURATEUR GUIDE",
      heroTitle: "Everything you need, in one place",
      heroIntro: "From zero to first order in minutes. Detailed sections, practical FAQs, sales tips.",
      tocTitle: "Index",
      tipsLabel: "Tips",
      faqTitle: "Frequently asked questions",
      quickstart: {
        kicker: "5-MINUTE START",
        title: "Quick start",
        intro: "Follow these 5 steps and receive your first order today.",
        steps: [
          { title: "Register and start your 3-day free trial", body: "Go to /register, fill in VAT, address and email. You're in the dashboard immediately." },
          { title: "Create your restaurant", body: "From the Dashboard click 'Create restaurant'. You'll get a public link /r/your-slug." },
          { title: "Add dishes (or import from PDF)", body: "On the 'Menu' tab enter dishes manually or upload your menu PDF: AI parses it and creates dishes." },
          { title: "Configure payments", body: "On 'Payments' tab: connect Stripe, PayPal.me or Satispay. At least one must be active." },
          { title: "Share your public link", body: "Copy your link from the Dashboard and paste it on your website, Google Business, social, QR menu. It's live 24/7." },
        ],
        tips: ["Set logo, primary color and cover photo to personalise.", "Configure opening hours: orders only flow during opening times."],
      },
      register: {
        kicker: "ACCESS",
        title: "Registration & login",
        intro: "Your restaurateur account is separate from customers. The free trial lasts 3 days.",
        steps: [
          { title: "Go to /register", body: "Provide email, password (min 6), business name, VAT, address. You get a JWT token saved in your browser." },
          { title: "3-day free trial", body: "Status 'trial' visible on top of the Dashboard. After expiry pick Basic 4.60€/mo or Pro 9.90€/mo." },
          { title: "Subsequent logins", body: "Go to /login with the same email & password. Password reset: contact info@renova360.it." },
          { title: "Logout", body: "Click the exit icon top-right. The token is wiped from your browser." },
        ],
      },
      subscription: {
        kicker: "BILLING",
        title: "Basic / Pro / Extra subscription",
        intro: "Monthly plans, managed from the 'Subscription' tab.",
        steps: [
          { title: "Basic — 4.60€/mo", body: "1 restaurant, unlimited menu, unlimited orders, card/Satispay/PayPal/cash payments." },
          { title: "Pro — 9.90€/mo", body: "Everything in Basic + advanced features (loyalty points, analytics, AI menu import)." },
          { title: "Extra restaurant — +3.00€/mo", body: "If you run multiple locations under the same legal entity." },
          { title: "Renova 6% commission", body: "Only on completed orders, never on the subscription. Stripe handles it automatically; Satispay/PayPal/cash accumulate as debt to settle (default threshold 50€)." },
        ],
        tips: ["Switch plans anytime.", "Expired subscription pauses the restaurant (never deletes it)."],
      },
      menu: {
        kicker: "MENU",
        title: "Menu management",
        intro: "Add dishes manually or via AI PDF import in seconds.",
        steps: [
          { title: "Add a dish", body: "Menu tab → name, description, price, category, allergens. Drag & drop a photo." },
          { title: "Edit / delete", body: "Pencil icon to edit, trash to delete. Changes are instant." },
          { title: "PDF import (AI)", body: "Upload your menu PDF: AI extracts names, prices, descriptions and creates dishes." },
          { title: "Allergens", body: "Tick the 14 standard EU allergens per dish — they appear as colored chips to customers." },
        ],
        tips: ["Real food photos convert 40% more than stock.", "A 1-2 line description boosts per-dish sales."],
      },
      orders: {
        kicker: "ORDERS",
        title: "Real-time order management",
        intro: "Orders appear in the 'Orders' tab: payment, pickup/delivery, customer contact, total.",
        steps: [
          { title: "Accept the order", body: "Click 'Accept' setting estimated prep time. Customer sees their ETA." },
          { title: "Reject (rare)", body: "If you must, click 'Reject'. Stripe auto-refunds; cash/Satispay/PayPal nothing was charged yet." },
          { title: "Advance status", body: "Paid → Accepted → Preparing → Ready/Out for delivery → Delivered. Customer tracks live." },
          { title: "Confirm cash/PayPal/Satispay payment", body: "When you receive manual payment click 'Mark paid'. Commission accrues." },
        ],
        tips: ["Leaving an order pending >5 minutes hurts UX: set up audio alerts.", "For delivery, move to 'Out for delivery' when the rider departs."],
      },
      payments: {
        kicker: "PAYOUTS",
        title: "Payment methods",
        intro: "Customers pay you directly (not Renova). Renova only takes the 6% commission.",
        steps: [
          { title: "Stripe Connect (card)", body: "Payments tab → 'Connect Stripe'. KYC on Stripe (VAT + IBAN). Payouts in 2-7 days. Commission deducted automatically." },
          { title: "Satispay", body: "Enter your Satispay activation code (Business Satispay app). Customer gets a dynamic QR. Confirm receipt manually." },
          { title: "PayPal.me", body: "Enter your PayPal.me handle. Customer clicks and pays on your PayPal page. Confirm receipt." },
          { title: "Cash on pickup", body: "Pickup orders only. Customer pays at counter. Confirm receipt from Dashboard." },
        ],
        tips: ["Enable Stripe + at least one alternative to maximise conversions.", "Complete Stripe KYC within 7 days or payouts get frozen."],
      },
      pickup: {
        kicker: "ORDERS",
        title: "Pickup vs. Delivery",
        intro: "Customer picks 'Delivery' (with address) or 'Pickup' (in-store).",
        steps: [
          { title: "Delivery", body: "Customer provides address. You charge delivery_fee. Digital payment only." },
          { title: "Pickup", body: "No address, no delivery fee. Customer can pay digital or cash at counter." },
          { title: "ETA", body: "On accept, set the prep time. Customer sees exact ready time." },
        ],
      },
      loyalty: {
        kicker: "RETENTION",
        title: "Loyalty points program",
        intro: "Reward returning customers. Points accrue automatically on every paid order.",
        steps: [
          { title: "Enable the program", body: "Settings tab → Loyalty section → 'Enable loyalty program'." },
          { title: "Set the ratio", body: "E.g. 1 point per 1€. Redeem value: 0.05€/point (1 point = 5¢ discount)." },
          { title: "Min redeem threshold", body: "Default 20 — customer can only redeem when balance ≥ 20." },
          { title: "Customer pays & accrues", body: "Orders reaching 'paid' credit the customer. On storefront they see balance and redeem at checkout." },
        ],
        tips: ["Communicate clearly: '1€ = 1 point. 20 points = 1€ off'.", "A well-tuned loyalty boosts repeat orders 25-40%."],
      },
      google: {
        kicker: "MARKETING",
        title: "Connect your link on Google Business",
        intro: "Add the 'Order online' button to your Google Business listing to capture Maps + Search traffic.",
        steps: [
          { title: "Find your Google Business profile", body: "Search your restaurant on Maps. The listing must show photos, hours, reviews. If missing, create free at business.google.com." },
          { title: "Open the 'Publish FoodGo link on Google' card", body: "It's in the Dashboard, right under your public link." },
          { title: "Enter profile URL (and/or Place ID)", body: "Copy your restaurant's Google Maps link. Place ID is optional but more accurate." },
          { title: "Click 'Connect Google Business'", body: "FoodGo copies the order link to your clipboard and opens Google Business in a new tab. Follow the 3-step overlay to paste." },
        ],
        tips: ["Complete your Google Business profile: complete profiles get 7x more orders.", "The 'Order online' button appears within 24-48h."],
      },
      commissions: {
        kicker: "RENOVA · 6%",
        title: "Renova commissions and auto-suspension",
        intro: "Renova keeps 6% on every paid order. Auto on Stripe; accrues as debt on others.",
        steps: [
          { title: "Card orders (Stripe)", body: "Commission deducted automatically at payment. Nothing to do." },
          { title: "Satispay/PayPal/Cash orders", body: "Commission accrues as 'debt'. Visible in the Dashboard banner." },
          { title: "Settle anytime", body: "Click 'Pay now' in the banner. Card payment, receipt included." },
          { title: "Auto-suspension threshold", body: "Default 50€. Exceeded → restaurant auto-paused. Auto-resumes upon settlement." },
        ],
        tips: ["Settle weekly to avoid interruptions.", "Threshold can be customised by Renova Super Admin."],
      },
      faq: [
        { q: "How much does FoodGo cost?", a: "4.60€/mo Basic, 9.90€/mo Pro. Plus 6% commission ONLY on received orders. No setup, no lock-in." },
        { q: "Can I use it for free?", a: "3-day free trial. After that you must activate a plan to keep receiving orders." },
        { q: "When do I get the money?", a: "Stripe: 2-7 days to your bank. Satispay/PayPal: instant. Cash: at pickup." },
        { q: "Does Renova charge my bank account?", a: "Never. Stripe pays you directly. Renova invoices the subscription and you settle the 6% commission upon reaching the threshold — never auto-debited." },
        { q: "What if I reject an order?", a: "Stripe auto-refunds the customer. Satispay/PayPal/cash never charged, nothing to refund." },
        { q: "Can I sell alcohol?", a: "Yes, complying with local laws (e.g. no minors). FoodGo is a neutral platform: legal compliance is on the restaurateur." },
        { q: "Can I cancel my account?", a: "Yes — email info@renova360.it. Cancelled within 24h, unused proration refunded." },
        { q: "Do customers need an account?", a: "Yes — one-click Google sign-in at checkout. Required for loyalty tracking and anti-fraud." },
        { q: "Can I export my data?", a: "Yes — Settings → Export. CSV orders, menu, customers. Your data is yours." },
        { q: "Does it work on mobile?", a: "Yes — both dashboard and customer storefront are mobile-first responsive. No app to install." },
      ],
    },
    billing: {
      kicker: "BILLING DETAILS",
      title: "Invoicing details",
      subtitle: "Required to activate any paid plan. Renova uses these to issue monthly invoices.",
      companyLabel: "Company name / Full name *",
      vatLabel: "VAT / Tax ID *",
      addressLabel: "Address *",
      emailLabel: "Billing email *",
      pecLabel: "PEC or SDI code (0000000 if none) *",
      phoneLabel: "Phone *",
      save: "Save billing details",
      cancel: "Cancel",
      edit: "Edit",
      savedOk: "Billing details saved.",
      requiredBeforeCheckout: "Fill in your billing details before activating the subscription.",
    },
    dashboard: {
      title: "Restaurateur dashboard",
      welcome: "Hi",
      noRestaurants: "You have no restaurants yet. Create one to start.",
      create: "Create restaurant",
      orders: "Orders",
      menu: "Menu",
      settings: "Settings",
      payments: "Payments",
      subscription: "Subscription",
      guide: "📖 Instructions",
      yourLink: "Your public link",
      copyLink: "Copy link",
      copied: "Copied!",
      addDish: "Add dish",
      dishName: "Dish name",
      dishDesc: "Description",
      dishPrice: "Price €",
      dishImage: "Image URL",
      dishCategory: "Category",
      save: "Save",
      delete: "Delete",
      noDishes: "No dishes. Add the first one!",
      generalInfo: "General information",
      name: "Restaurant name",
      description: "Description",
      address: "Address",
      phone: "Phone",
      logoUrl: "Logo URL",
      coverUrl: "Cover banner URL",
      primaryColor: "Primary color",
      hours: "Opening hours",
      deliveryTime: "Delivery time (min)",
      deliveryFee: "Delivery fee €",
      tipToggle: "Optional rider tip",
      urgencyToggle: "Priority delivery",
      urgencyFee: "Priority delivery fee €",
      urgencyLabel: "Urgency label",
      promoMessage: "Promo message",
      promoDiscount: "Promo discount %",
      stripeAccountId: "Stripe Connect ID (acct_...)",
      paypalEmail: "PayPal email",
      satispayHandle: "Satispay (phone or handle)",
      customerNotes: "Customer notes",
      pointsAwarded: "Points for this order",
      customerPoints: "Customer total points",
      markPaidPaypal: "Paid via PayPal",
      markPaidSatispay: "Paid via Satispay",
      confirmMarkPaid: "Confirm you have received the payment for this order?",
      paymentSettings: "Payment settings",
      paymentInfo: "Enter your Stripe Connect: customers pay you directly (Renova keeps 6%).",
      saved: "Saved",
      ordersTitle: "Your orders",
      noOrders: "No orders yet.",
      status: "Status",
      total: "Total",
      customer: "Customer",
      subscriptionTitle: "Subscription",
      planBasic: "Basic €4.60/mo",
      planPro: "Pro €9.90/mo",
      extraRest: "Extra restaurants",
      activate: "Activate subscription",
      active: "Active",
      trial: "TRIAL",
      inactive: "Inactive",
      until: "Valid until",
      newRestName: "New restaurant name",
      preview: "View page",
      trialBannerTitle: "You're on free trial",
      trialBannerSub: "{d} days left. Activate a plan to keep your page online.",
      trialExpired: "Trial expired — activate a plan to continue",
      mark: { pending: "Pending", paid: "Paid", accepted: "Accepted", preparing: "Preparing", ready: "Ready for pickup", out_for_delivery: "Out for delivery", delivered: "Delivered", cancelled: "Cancelled", rejected: "Rejected" },
      accept: "Accept",
      reject: "Reject",
      markPreparing: "Preparing",
      markReady: "Ready for pickup",
      markOut: "Out for delivery",
      updateEta: "Update ETA",
      updateTime: "Update Time",
      deliverTo: "Deliver to",
      pickupInStore: "In-store pickup",
      statusOpen: "Restaurant OPEN",
      statusClosed: "Restaurant CLOSED",
      openHint: "You are accepting customer orders.",
      closedHint: "No orders can be placed by customers.",
      openRestaurant: "Open restaurant",
      closeRestaurant: "Close restaurant",
      deleteRestaurant: "Delete restaurant",
      deleteConfirmTitle: "Delete this restaurant?",
      deleteConfirmBody: "This will permanently delete the RESTAURANT, all DISHES, ORDERS and TRANSACTIONS. This operation is IRREVERSIBLE.",
      deleteConfirmTypeHint: "To confirm, type the restaurant name",
      deleteYes: "Yes, delete permanently",
      weeklyHours: "Weekly hours",
      weeklyHoursHint: "Outside hours, the system automatically rejects orders. Leave all toggles off to always be open.",
      dayNames: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      copyMonToAll: "Copy Mon → all",
      clearAll: "Clear all",
      addSlot: "Add slot",
      closedDay: "Closed",
      loyalty: {
        title: "Loyalty points",
        hint: "Customers earn points on every paid order and can redeem them at checkout.",
        on: "On",
        off: "Off",
        pointsPerEuro: "Points per € spent",
        euroPerPoint: "€ per point",
        minRedeem: "Min. points to redeem",
        preview: "Preview: {ppe} pt per € spent · {ept} € off per point",
      },
      commission: {
        title: "Commissions to settle",
        hint: "Auto-charged once you reach € 50. You can also pay now at any time.",
        dueHint: "You exceeded the € 50 threshold: settle your commissions owed to Renova now.",
        orders: "cash orders",
        payNow: "Pay now",
      },
      waitingCustomer: "Waiting customer confirmation",
      refundManual: "manual refund",
      edit: "Edit",
      editDish: "Edit dish",
      cancel: "Cancel",
      dishIngredients: "Ingredients",
      dishAllergens: "Allergens",
      menuImportTitle: "Import menu PDF",
      menuImportSub: "Upload a PDF of your menu: AI extracts name, description, ingredients and allergens.",
      menuPickPdf: "Pick PDF",
      dishesFound: "dishes found",
      menuImportConfirm: "Add all",
      menuImportEmpty: "No dish recognized. Try a clearer PDF.",
      uploadingPdf: "Uploading PDF",
      aiProcessing: "AI processing",
      savingDishes: "Saving dishes",
      aiHint: "Gemini is parsing the PDF, may take 10-20s",
      extraGraceTitle: "Restaurant on extra trial",
      extraGraceSub: "You have {d} days to pay €3.00/mo, otherwise this restaurant will be blocked (not deleted).",
      extraExpiredTitle: "Restaurant blocked",
      extraExpiredSub: "3-day grace period expired. Pay €3.00 to reactivate it.",
      payExtraNow: "Pay €3.00 now",
      extraGraceBadge: "EXTRA TRIAL",
      extraBlockedBadge: "BLOCKED",
      extraPaidBadge: "EXTRA OK",
      extraPaidUntil: "Paid until",
      extraCreatedToastTitle: "Restaurant created!",
      extraCreatedToastSub: "You have 3 trial days. Then €3.00/mo to keep it active.",
      lockedManually: "Blocked by admin",
      lockedOwnerSub: "Main subscription expired",
      renewalSoonTitle: "Subscription expiring soon",
      renewalSoonSub: "Expires in {d} days. Renew now to avoid service interruption.",
      renew: "Renew now",
      connectTitle: "Stripe Connect",
      connectSub: "Connect your Stripe account to receive customer payments directly (Renova keeps 6%).",
      connectBtn: "Connect with Stripe",
      connectContinue: "Finish setup",
      connectConnected: "Connected",
      connectDisabledDemo: "Available only in production with a real Stripe key.",
      connectCharges: "Payments",
      connectPayouts: "Payouts",
      analyticsTitle: "Analytics last {d} days",
      gmv: "GMV",
      commission: "Commission 6%",
      ordersCount: "Orders",
      topRestaurants: "Top restaurants"
    },
    storefront: {
      menu: "Menu",
      cart: "Cart",
      empty: "Cart is empty",
      add: "Add",
      remove: "Remove",
      subtotal: "Subtotal",
      loyaltyTitle: "Your points",
      loyaltyDiscount: "Points discount",
      loyaltyMinHint: "Minimum {n} points to redeem",
      loyaltyNeedMore: "You need at least {n} points to redeem. {x} more to go.",
      pointsLabel: "Points",
      pointsShort: "pt",
      myOrdersLink: "My orders",
      googleSignup: "Sign up with Google",
      tip: "Rider tip",
      tipHelp: "Leave a tip for your rider (optional)",
      urgency: "Priority delivery",
      delivery: "Delivery",
      pickup: "Pickup",
      pickupAt: "Pick up at",
      payOnDelivery: "Pay on delivery",
      payOnPickup: "Pay on pickup",
      payOnArrivalHint: "You will pay the restaurant directly in cash.",
      choosePayment: "Choose how to pay",
      payNowStripe: "Pay with card (Stripe)",
      notesLabel: "Order notes (allergies, preferences)",
      notesPlaceholder: "E.g. no tomato, dairy-free, well done...",
      methodInactive: "This method is not active by the restaurant",
      activeOrderTag: "Active order",
      activeOrdersCount: "{n} active orders",
      openBadge: "Open",
      closedBadge: "Closed",
      outsideHours: "Outside hours",
      closedNoOrders: "Restaurant closed",
      outsideHoursNoOrders: "Outside opening hours",
      trackOrder: "Track order",
      cashPayment: "PAY ON ARRIVAL",
      discount: "Discount",
      total: "Total",
      checkout: "Checkout",
      yourInfo: "Your details",
      loginRequired: "Sign in with Google to order",
      loginRequiredSub: "We ask you to sign in to submit the order securely.",
      loginGoogle: "Continue with Google",
      name: "Name",
      phone: "Phone",
      address: "Delivery address",
      notes: "Notes for the restaurant",
      payNow: "Pay now",
      processing: "Processing...",
      deliveryTime: "Delivery in ~{min} min",
      successTitle: "Payment received!",
      successDesc: "Thank you. The restaurant has received your order.",
      backHome: "Back to restaurant",
      promoBanner: "Active promo: -{p}%",
      loggedAs: "Ordering as",
      lockedTitle: "Restaurant temporarily unavailable",
      lockedSub: "This restaurant is currently blocked. Please try again later."
    },
    admin: {
      title: "Renova 360 — Super Admin",
      kpiRestaurants: "Active restaurants",
      kpiCommission: "Renova commission (6%)",
      kpiCommissionCollected: "Collected",
      kpiCommissionToCollect: "To collect",
      kpiSubs: "Subscription revenue",
      kpiOrders: "Paid orders",
      kpiGmv: "Total GMV",
      kpiActiveSubs: "Active accounts",
      list: "Restaurants list",
      orders: "Recent orders",
      block: "Block",
      unblock: "Unblock",
      suspend: "Suspend",
      unsuspend: "Reactivate",
      cancel: "Cancel",
      restore: "Restore",
      delete: "Delete",
      suspended: "Suspended",
      cancelled: "Cancelled",
      suspendReasonPrompt: "Suspension reason (optional):",
      deleteConfirmPrompt: "To PERMANENTLY delete restaurant {n} (and all its data: dishes, orders, transactions) type CANCELLA",
      open: "Open",
      accounting: "Accounting",
      ledger: "Ledger entries",
      noLedger: "No entries yet",
      gmv: "GMV",
      commissionTotal: "Commission 6%",
      commissionSettled: "Settled",
      commissionPending: "Pending cash",
      subscriptions: "Subscriptions",
      extraResto: "Extra rest.",
      revenueRenova: "Renova revenue"
    },
    footer: {
      tagline: "The white-label delivery platform for independent restaurants. You sell, we disappear behind the scenes.",
      legalTitle: "Legal",
      companyTitle: "Company",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      terms: "Terms & Conditions"
    },
    myOrders: {
      tag: "CUSTOMER ORDERS",
      title: "My orders",
      sub: "Track your orders in real time.",
      empty: "You haven't placed any orders yet.",
      loginPrompt: "Sign in with Google from a restaurant to start.",
      back: "Back",
      backToRestaurant: "Back to restaurant",
      confirmDelivered: "Confirm delivery",
      summary: "Order summary",
      rejectedTitle: "Order rejected",
      refundManual: "The restaurant will handle the refund manually in Stripe.",
      refundStatus: "Refund status",
      pointsForOrder: "Points for this order",
      pointsTotal: "Total points",
      cashPay: "Cash",
      itemSingular: "item",
      itemPlural: "items"
    }
  },
  es: {
    nav: { login: "Entrar", register: "Registrarse", dashboard: "Panel", admin: "SA", logout: "Salir", pricing: "Precios", features: "Funciones", howItWorks: "Cómo funciona", myOrders: "Mis pedidos" },
    landing: {
      tag: "by Renova 360",
      heroTitle1: "Tu restaurante.",
      heroTitle2: "Tus pedidos.",
      heroAccent: "Cero marketplace.",
      heroSub: "Crea la página de delivery de tu restaurante en 5 minutos. Los clientes piden y te pagan directamente. 3 días gratis, después 4,60€/mes.",
      cta: "Empieza 3 días gratis",
      ctaSecondary: "Ver precios",
      bullet1: "Pagos directos vía Stripe",
      bullet2: "Solo 6% de comisión",
      bullet3: "Sin competencia en tu página",
      featuresTitle: "Todo lo que necesitas para el delivery",
      f1Title: "Menú personalizado",
      f1Desc: "Sube platos, fotos, precios, categorías. Promos automáticas.",
      f2Title: "100% tu marca",
      f2Desc: "Logo, banner, colores. Tu enlace listo para compartir.",
      f3Title: "Propina y urgencia",
      f3Desc: "Propina opcional y entrega prioritaria con coste extra.",
      f4Title: "Pago directo",
      f4Desc: "Los clientes te pagan vía Stripe. Renova retiene solo el 6%.",
      pricingTitle: "Un plan para cada cocina",
      pricingSub: "Tres días de prueba gratis. Cancela cuando quieras.",
      trial: "3 DÍAS GRATIS",
      basicTitle: "Basic",
      basicPrice: "4,60€",
      basicPer: "/mes",
      basicDesc: "Para empezar",
      proTitle: "Pro",
      proPrice: "9,90€",
      proPer: "/mes",
      proDesc: "Para crecer",
      extraInfo: "+3,00€/mes por restaurante adicional",
      commissionInfo: "Comisión Renova: 6% sobre pedidos",
      basicFeat1: "1 restaurante",
      basicFeat2: "Menú ilimitado",
      basicFeat3: "Página personalizable",
      basicFeat4: "Stripe Connect",
      proFeat1: "Todo de Basic",
      proFeat2: "Promos avanzadas",
      proFeat3: "Propina + Urgencia",
      proFeat4: "Estadísticas y pedidos ilimitados",
      ctaPlan: "Empezar gratis",
      howTitle: "Tres pasos para empezar",
      step1: "Regístrate con NIF/CIF",
      step1Desc: "Crea tu cuenta en 60 segundos.",
      step2: "Personaliza tu página",
      step2Desc: "Añade logo, menú, horarios, propina, urgencia.",
      step3: "Comparte el enlace",
      step3Desc: "Web, redes, QR en mesas. Los clientes te pagan directamente.",
      footer: "© 2026 FoodGo — by Renova 360. Todos los derechos reservados.",
      saLink: "SA"
    },
    footer: {
      tagline: "La plataforma de delivery white-label para restaurantes independientes. Tú vendes, nosotros desaparecemos detrás del telón.",
      legalTitle: "Legal",
      companyTitle: "Empresa",
      privacy: "Política de privacidad",
      cookies: "Política de cookies",
      terms: "Términos y condiciones"
    },
    cookies: {
      bannerTitle: "Cookies y Privacidad",
      bannerText: "Usamos cookies técnicas esenciales y — solo con tu consentimiento — cookies analíticas para mejorar el servicio. Puedes cambiar de opinión cuando quieras.",
      privacyLink: "Privacidad",
      cookieLink: "Política de cookies",
      acceptAll: "Aceptar todas",
      rejectAll: "Solo esenciales",
      customize: "Personalizar",
      savePrefs: "Guardar preferencias",
      essentialLabel: "Esenciales (siempre activas)",
      essentialDesc: "Necesarias para autenticación, seguridad y funcionamiento.",
      analyticsLabel: "Analíticas",
      analyticsDesc: "Estadísticas agregadas para mejorar el producto. Sin perfilado.",
      marketingLabel: "Marketing",
      marketingDesc: "Anuncios personalizados y partners (desactivadas por defecto)."
    },
    legal: {
      lastUpdate: "Última actualización",
      contactTitle: "Responsable del tratamiento",
      privacy: {
        tag: "POLÍTICA DE PRIVACIDAD",
        title: "Política de Privacidad (RGPD)",
        sections: [
          { h: "1. Responsable", p: ["El responsable del tratamiento es Makai, NIF italiano IT09936410969, contactable en renova360@renova360.it."] },
          { h: "2. Datos recogidos", p: ["Recogemos:"], list: ["Datos del restaurador: nombre, email, razón social, NIF/CIF, dirección, teléfono.", "Datos del cliente: nombre, teléfono, dirección, email (Google OAuth).", "Datos de pago gestionados por Stripe (no los almacenamos).", "Datos de navegación: cookies técnicas y — con consentimiento — analíticas."] },
          { h: "3. Finalidades", p: ["(a) Prestar el servicio FoodGo; (b) facturación y suscripción; (c) reenviar los pedidos al restaurador; (d) obligaciones fiscales y contables; (e) — con consentimiento — analítica y marketing."] },
          { h: "4. Base legal", p: ["Ejecución contractual (art. 6.1.b RGPD), obligaciones legales (art. 6.1.c), interés legítimo (art. 6.1.f) y consentimiento (art. 6.1.a)."] },
          { h: "5. Conservación", p: ["Datos fiscales: 10 años (ley italiana). Cuentas inactivas: 24 meses tras aviso previo."] },
          { h: "6. Derechos", p: ["Acceso, rectificación, supresión, limitación, oposición y portabilidad. Contacto: renova360@renova360.it."] },
          { h: "7. Terceros", p: ["Stripe (pagos), Google (OAuth cliente), proveedores de hosting. Todos cumplen el RGPD o cláusulas contractuales tipo."] },
          { h: "8. Reclamaciones", p: ["Puedes reclamar ante la autoridad de protección de datos italiana (www.garanteprivacy.it)."] }
        ]
      },
      cookies: {
        tag: "POLÍTICA DE COOKIES",
        title: "Política de Cookies",
        sections: [
          { h: "1. Qué son", p: ["Pequeños ficheros guardados en tu dispositivo para hacer funcionar el sitio y analizar el uso."] },
          { h: "2. Cookies técnicas (siempre activas)", p: ["Usamos localStorage/sessionStorage para: mantener la sesión (token JWT), guardar el idioma, recordar el carrito. Sin ellas el sitio no funciona."] },
          { h: "3. Analíticas", p: ["Solo con consentimiento, estadísticas anónimas para mejorar el producto. Sin perfilado individual."] },
          { h: "4. Marketing", p: ["Desactivadas por defecto. Solo con consentimiento explícito."] },
          { h: "5. Gestión", p: ["Puedes cambiar tus preferencias eliminando la clave 'foodgo_cookie_consent_v1' del navegador."] }
        ]
      },
      terms: {
        tag: "TÉRMINOS",
        title: "Términos del servicio",
        sections: [
          { h: "1. Objeto", p: ["Este contrato regula el uso de FoodGo by Renova 360, un producto Makai, NIF italiano IT09936410969."] },
          { h: "2. Prueba y suscripción", p: ["Cada nuevo restaurador dispone de 3 días de prueba gratuita. Tras la prueba se requiere un plan (Basic 4,60€/mes o Pro 9,90€/mes). Restaurantes extra: 3,00€/mes c/u."] },
          { h: "3. Comisión", p: ["Por cada pedido pagado, Renova retiene el 6%. El 94% restante se abona al restaurador."] },
          { h: "4. Obligaciones del restaurador", p: ["NIF válido, datos y precios correctos, gestión de pedidos, cumplimiento de normativa HACCP y de seguridad alimentaria."] },
          { h: "5. Cancelación", p: ["La suscripción es mensual y se puede cancelar cuando se quiera; los importes ya pagados no son reembolsables."] },
          { h: "6. Responsabilidad", p: ["FoodGo es un intermediario tecnológico: la responsabilidad sobre preparación, calidad y entrega es del restaurador."] },
          { h: "7. Jurisdicción", p: ["Cualquier controversia se somete al Tribunal de Roma, Italia."] }
        ]
      }
    },
    auth: {
      registerTitle: "Crea tu cuenta",
      registerSub: "3 días de prueba gratis. Sin tarjeta.",
      loginTitle: "Bienvenido de vuelta",
      loginSub: "Accede a tu cuenta de restaurador",
      saTitle: "Renova 360 — Super Admin",
      saSub: "Área reservada Renova",
      email: "Email",
      password: "Contraseña",
      fullName: "Nombre completo",
      businessName: "Razón social",
      vat: "CIF / NIF / VAT",
      address: "Dirección exacta",
      phone: "Teléfono",
      submitRegister: "Crear cuenta",
      submitLogin: "Entrar",
      submitSa: "Entrar como Super Admin",
      hasAccount: "¿Ya tienes cuenta?",
      noAccount: "¿No tienes cuenta?",
      loginCta: "Entrar",
      registerCta: "Registrarse",
      back: "Volver al inicio",
      acceptTerms: "Acepto los Términos y he leído la Política de Privacidad",
      termsRequired: "Debes aceptar los Términos para crear la cuenta",
      errorGeneric: "Algo salió mal. Inténtalo de nuevo.",
      processing: "Espera...",
      forgotLink: "¿Contraseña olvidada?",
      forgotTitle: "Recuperar contraseña",
      forgotSub: "Introduce tu email. Te enviaremos un enlace para restablecer la contraseña.",
      forgotCta: "Enviar enlace",
      forgotDoneTitle: "Revisa tu email",
      forgotDoneSub: "Si el correo está registrado, recibirás un enlace de recuperación. Caduca en 30 minutos.",
      devLinkLabel: "Modo desarrollo · enlace directo",
      resetTitle: "Nueva contraseña",
      resetSub: "Elige una nueva contraseña para tu cuenta.",
      resetCta: "Actualizar contraseña",
      resetDoneTitle: "¡Contraseña actualizada!",
      resetDoneSub: "Ya puedes acceder con la nueva contraseña.",
      missingToken: "Enlace no válido o caducado. Solicita uno nuevo.",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar contraseña",
      passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
      passwordsDontMatch: "Las contraseñas no coinciden"
    },
    gbp: {
      title: "Publica el enlace FoodGo en Google",
      subtitle: "Introduce los datos de tu perfil Google Business y publica el botón «Pedir online» con el enlace FoodGo de tu restaurante.",
      connect: "Conectar Google Business",
      businessUrlLabel: "URL de tu perfil Google Business",
      businessUrlPh: "Ej. https://g.page/mi-restaurante o enlace Google Maps",
      businessUrlHint: "Abre Google Maps, busca tu restaurante, pulsa «Compartir» y copia el enlace.",
      placeIdLabel: "Google Place ID (opcional, más preciso)",
      placeIdHint: "Encuentra tu Place ID en",
      urlToPublish: "Enlace para pegar en Google",
      copy: "Copiar",
      fillFirst: "Rellena al menos uno de los campos arriba para activar el botón.",
      linkCopied: "¡Enlace FoodGo copiado! Pégalo en el campo «Pedir online» de Google.",
      linkCopyManual: "Abriendo Google Business. Copia manualmente el enlace de arriba.",
      guideTitle: "Publica el enlace en Google Business",
      guideIntro: "Abrimos Google Business en una pestaña nueva y copiamos el enlace FoodGo en el portapapeles. Sigue estos 3 pasos:",
      guideStep1: "En la pestaña de Google Business recién abierta, haz clic en «Editar perfil».",
      guideStep2: "Busca la sección «Pedidos» o «Enlace para pedir» y pega este URL:",
      guideStep3: "Haz clic en «Guardar». En unos minutos Google mostrará el botón «Pedir online» en tu perfil.",
      copyAgain: "Copiar de nuevo",
      guideDone: "Hecho",
    },
    guide: {
      kicker: "GUÍA RESTAURADOR",
      heroTitle: "Todo lo que necesitas, en un solo lugar",
      heroIntro: "De cero al primer pedido en minutos. Secciones detalladas, FAQ prácticas y consejos para vender más.",
      tocTitle: "Índice",
      tipsLabel: "Consejos",
      faqTitle: "Preguntas frecuentes",
      quickstart: {
        kicker: "ARRANCA EN 5 MIN",
        title: "Inicio rápido",
        intro: "Sigue estos 5 pasos y recibe tu primer pedido hoy.",
        steps: [
          { title: "Regístrate y activa la prueba gratuita de 3 días", body: "Ve a /register, rellena CIF/NIF, dirección y email. Entras al panel al instante." },
          { title: "Crea tu restaurante", body: "Desde el Dashboard pulsa «Crear restaurante». Obtendrás un enlace público /r/tu-slug." },
          { title: "Añade los platos (o impórtalos del PDF)", body: "En la pestaña «Menú» añade platos manualmente o sube tu PDF: la IA lo analiza." },
          { title: "Configura los pagos", body: "Pestaña «Pagos»: conecta Stripe, PayPal.me o Satispay. Al menos uno activo." },
          { title: "Comparte el enlace público", body: "Copia el enlace y ponlo en tu web, Google Business, redes sociales, menú QR. Online 24/7." },
        ],
        tips: ["Pon logo, color principal y portada para personalizar.", "Configura el horario de apertura."],
      },
      register: {
        kicker: "ACCESO",
        title: "Registro y acceso",
        intro: "Tu cuenta de restaurador está separada de la de los clientes. Prueba gratis 3 días.",
        steps: [
          { title: "Ve a /register", body: "Email, contraseña (mín 6), razón social, CIF, dirección. Recibes un JWT en el navegador." },
          { title: "Prueba gratis 3 días", body: "Estado 'trial' visible en el Dashboard. Al expirar elige Basic 4,60€/mes o Pro 9,90€/mes." },
          { title: "Logins posteriores", body: "/login con el mismo email y contraseña. Reset: info@renova360.it." },
          { title: "Cerrar sesión", body: "Icono de salida arriba a la derecha." },
        ],
      },
      subscription: {
        kicker: "FACTURACIÓN",
        title: "Suscripción Basic / Pro / Extra",
        intro: "Planes mensuales gestionados desde la pestaña «Suscripción».",
        steps: [
          { title: "Basic — 4,60€/mes", body: "1 restaurante, menú ilimitado, pedidos ilimitados, todos los pagos." },
          { title: "Pro — 9,90€/mes", body: "Todo de Basic + funciones avanzadas (fidelización, analytics, import IA)." },
          { title: "Restaurante extra — +3,00€/mes", body: "Para múltiples sedes con la misma persona jurídica." },
          { title: "Comisión Renova 6%", body: "Solo sobre pedidos completados. Stripe lo gestiona auto; Satispay/PayPal/cash se acumulan como deuda (umbral 50€)." },
        ],
        tips: ["Cambia de plan cuando quieras.", "Suscripción vencida pausa el restaurante (no lo borra)."],
      },
      menu: {
        kicker: "MENÚ",
        title: "Gestión del menú",
        intro: "Añade platos manualmente o vía IA desde PDF en segundos.",
        steps: [
          { title: "Añadir plato", body: "Pestaña Menú → nombre, descripción, precio, categoría, alérgenos. Foto con drag & drop." },
          { title: "Editar / eliminar", body: "Lápiz para editar, papelera para borrar. Los cambios son instantáneos." },
          { title: "Importar PDF (IA)", body: "Sube tu PDF: la IA extrae nombres, precios y descripciones y crea los platos." },
          { title: "Alérgenos", body: "Marca los 14 alérgenos UE por plato — aparecen como chips coloreados al cliente." },
        ],
        tips: ["Fotos reales convierten 40% más que stock.", "Una descripción de 1-2 líneas dispara las ventas."],
      },
      orders: {
        kicker: "PEDIDOS",
        title: "Gestión de pedidos en tiempo real",
        intro: "Los pedidos aparecen en la pestaña «Pedidos»: pago, recogida/entrega, contacto, total.",
        steps: [
          { title: "Aceptar el pedido", body: "Pulsa «Aceptar» indicando el tiempo de preparación. El cliente verá su ETA." },
          { title: "Rechazar (raro)", body: "Si no puedes, pulsa «Rechazar». Stripe reembolsa auto; cash/Satispay/PayPal aún no se ha cobrado." },
          { title: "Avanzar estado", body: "Pagado → Aceptado → Preparando → Listo/En reparto → Entregado. El cliente lo ve en vivo." },
          { title: "Confirmar pago manual", body: "Cuando recibas pago en efectivo/PayPal/Satispay pulsa «✓ Pagado»." },
        ],
        tips: ["No dejes un pedido pendiente >5 min.", "Para reparto, pasa a «En reparto» cuando salga el rider."],
      },
      payments: {
        kicker: "COBROS",
        title: "Métodos de pago",
        intro: "Los clientes te pagan a ti (no a Renova). Renova solo se queda con el 6%.",
        steps: [
          { title: "Stripe Connect (tarjeta)", body: "Pestaña Pagos → «Conectar Stripe». KYC en Stripe (CIF + IBAN). Liquidaciones 2-7 días. Comisión auto." },
          { title: "Satispay", body: "Introduce tu código de activación Satispay. El cliente recibe un QR dinámico. Confirma cobro manualmente." },
          { title: "PayPal.me", body: "Introduce tu handle PayPal.me. El cliente paga en tu página PayPal. Confirma cobro." },
          { title: "Pago en recogida (efectivo)", body: "Solo pedidos de recogida. El cliente paga en mostrador. Confirma desde Dashboard." },
        ],
        tips: ["Activa Stripe + al menos una alternativa.", "Completa el KYC de Stripe en 7 días o se congelan los pagos."],
      },
      pickup: {
        kicker: "PEDIDOS",
        title: "Recogida vs. Entrega",
        intro: "El cliente elige «Entrega» (con dirección) o «Recogida» (en local).",
        steps: [
          { title: "Entrega", body: "El cliente da la dirección. Cobras delivery_fee. Solo pago digital." },
          { title: "Recogida", body: "Sin dirección ni tarifa. Cliente puede pagar digital o en efectivo en mostrador." },
          { title: "Tiempo estimado", body: "Al aceptar, indicas el tiempo de preparación. El cliente ve la hora exacta." },
        ],
      },
      loyalty: {
        kicker: "FIDELIZACIÓN",
        title: "Programa de puntos",
        intro: "Premia a clientes recurrentes. Los puntos se acumulan en cada pedido pagado.",
        steps: [
          { title: "Activar programa", body: "Pestaña Ajustes → Loyalty → «Habilitar programa de fidelización»." },
          { title: "Define la ratio", body: "Ej. 1 punto por 1€. Valor de canje: 0,05€/punto." },
          { title: "Umbral mínimo de canje", body: "Por defecto 20: el cliente solo canjea con saldo ≥ 20." },
          { title: "Cliente acumula", body: "Pedidos en estado 'paid' acreditan al cliente. En el storefront ve saldo y canjea al checkout." },
        ],
        tips: ["Comunica: «1€ = 1 punto. 20 puntos = 1€ de descuento».", "Bien afinado, multiplica los pedidos recurrentes 25-40%."],
      },
      google: {
        kicker: "MARKETING",
        title: "Conecta tu enlace en Google Business",
        intro: "Añade el botón «Pedir online» a tu perfil Google Business y capta tráfico de Maps + Search.",
        steps: [
          { title: "Encuentra tu perfil", body: "Busca tu restaurante en Maps. Debe verse la ficha con fotos y reseñas. Si falta, créalo en business.google.com." },
          { title: "Abre la tarjeta «Publica el enlace FoodGo en Google»", body: "En el Dashboard, debajo de tu enlace público." },
          { title: "Introduce URL del perfil (y/o Place ID)", body: "Copia el enlace Google Maps de tu restaurante. Place ID es opcional pero más preciso." },
          { title: "Pulsa «Conectar Google Business»", body: "FoodGo copia tu enlace al portapapeles y abre Google Business en otra pestaña. Sigue la guía de 3 pasos." },
        ],
        tips: ["Perfil completo = 7x más pedidos.", "El botón aparece en 24-48 h."],
      },
      commissions: {
        kicker: "RENOVA · 6%",
        title: "Comisiones Renova y auto-suspensión",
        intro: "Renova retiene 6% en cada pedido pagado. Auto en Stripe; se acumula como deuda en otros.",
        steps: [
          { title: "Pedidos con tarjeta (Stripe)", body: "Comisión deducida al instante. Nada que hacer." },
          { title: "Satispay/PayPal/Efectivo", body: "Comisión acumulada como «deuda». Visible en el banner del Dashboard." },
          { title: "Liquida cuando quieras", body: "Pulsa «Pagar ahora». Tarjeta, recibo incluido." },
          { title: "Umbral de auto-suspensión", body: "50€ por defecto. Superado → restaurante en pausa automática. Reactivación auto al liquidar." },
        ],
        tips: ["Liquida semanalmente para evitar interrupciones.", "El Super Admin puede personalizar el umbral."],
      },
      faq: [
        { q: "¿Cuánto cuesta FoodGo?", a: "4,60€/mes Basic, 9,90€/mes Pro. Más 6% de comisión SOLO sobre pedidos recibidos. Sin alta, sin permanencia." },
        { q: "¿Puedo usarlo gratis?", a: "Tienes 3 días de prueba gratis. Después debes activar un plan." },
        { q: "¿Cuándo recibo el dinero?", a: "Stripe: 2-7 días al banco. Satispay/PayPal: instantáneo. Efectivo: en recogida." },
        { q: "¿Renova me cobra del banco?", a: "Nunca. Stripe te paga directo. Renova factura la suscripción y la comisión 6% al alcanzar el umbral, sin cargo automático." },
        { q: "¿Y si rechazo un pedido?", a: "Stripe reembolsa al cliente; Satispay/PayPal/efectivo nunca se cobró." },
        { q: "¿Puedo vender alcohol?", a: "Sí, respetando la legislación local. FoodGo es una plataforma neutral." },
        { q: "¿Puedo cancelar mi cuenta?", a: "Sí: info@renova360.it. Cancelación en 24 h, devolvemos el prorrateo no usado." },
        { q: "¿Los clientes necesitan cuenta?", a: "Sí: login Google de un clic en el checkout. Necesario para fidelización y antifraude." },
        { q: "¿Puedo exportar mis datos?", a: "Sí: Ajustes → Exportar. CSV pedidos, menú, clientes. Tus datos son tuyos." },
        { q: "¿Funciona en móvil?", a: "Sí, dashboard y storefront son mobile-first. No hay app que instalar." },
      ],
    },
    billing: {
      kicker: "DATOS DE FACTURACIÓN",
      title: "Datos de facturación",
      subtitle: "Obligatorios para activar la suscripción. Renova los usa para emitir facturas mensuales.",
      companyLabel: "Razón social / Nombre y apellidos *",
      vatLabel: "CIF / NIF *",
      addressLabel: "Dirección *",
      emailLabel: "Email de facturación *",
      pecLabel: "PEC o código SDI (0000000 si no tienes) *",
      phoneLabel: "Teléfono *",
      save: "Guardar datos",
      cancel: "Cancelar",
      edit: "Editar",
      savedOk: "Datos de facturación guardados.",
      requiredBeforeCheckout: "Rellena los datos de facturación antes de activar la suscripción.",
    },
    dashboard: {
      title: "Panel del restaurador",
      welcome: "Hola",
      noRestaurants: "Aún no tienes restaurantes. Crea uno para empezar.",
      create: "Crear restaurante",
      orders: "Pedidos",
      menu: "Menú",
      settings: "Ajustes",
      payments: "Pagos",
      subscription: "Suscripción",
      guide: "📖 Instrucciones",
      yourLink: "Tu enlace público",
      copyLink: "Copiar enlace",
      copied: "Copiado!",
      addDish: "Añadir plato",
      dishName: "Nombre del plato",
      dishDesc: "Descripción",
      dishPrice: "Precio €",
      dishImage: "URL imagen",
      dishCategory: "Categoría",
      save: "Guardar",
      delete: "Eliminar",
      noDishes: "Sin platos. ¡Añade el primero!",
      generalInfo: "Información general",
      name: "Nombre del restaurante",
      description: "Descripción",
      address: "Dirección",
      phone: "Teléfono",
      logoUrl: "URL logo",
      coverUrl: "URL banner",
      primaryColor: "Color primario",
      hours: "Horario",
      deliveryTime: "Tiempo de entrega (min)",
      deliveryFee: "Coste envío €",
      tipToggle: "Propina opcional",
      urgencyToggle: "Entrega prioritaria",
      urgencyFee: "Coste prioritaria €",
      urgencyLabel: "Etiqueta urgencia",
      promoMessage: "Mensaje promo",
      promoDiscount: "Descuento promo %",
      stripeAccountId: "ID Stripe Connect (acct_...)",
      paypalEmail: "Email PayPal",
      satispayHandle: "Satispay (teléfono o handle)",
      customerNotes: "Notas del cliente",
      pointsAwarded: "Puntos por este pedido",
      customerPoints: "Puntos cliente totales",
      markPaidPaypal: "Pagado vía PayPal",
      markPaidSatispay: "Pagado vía Satispay",
      confirmMarkPaid: "¿Confirmas haber recibido el pago de este pedido?",
      paymentSettings: "Ajustes de pago",
      paymentInfo: "Introduce tu Stripe Connect: los clientes te pagan directamente (Renova retiene 6%).",
      saved: "Guardado",
      ordersTitle: "Tus pedidos",
      noOrders: "Aún no hay pedidos.",
      status: "Estado",
      total: "Total",
      customer: "Cliente",
      subscriptionTitle: "Suscripción",
      planBasic: "Basic 4,60€/mes",
      planPro: "Pro 9,90€/mes",
      extraRest: "Restaurantes extra",
      activate: "Activar suscripción",
      active: "Activa",
      trial: "PRUEBA",
      inactive: "Inactiva",
      until: "Válida hasta",
      newRestName: "Nombre del nuevo restaurante",
      preview: "Ver página",
      trialBannerTitle: "Estás en prueba gratis",
      trialBannerSub: "Te quedan {d} días. Activa un plan para mantener tu página online.",
      trialExpired: "Prueba caducada — activa un plan para continuar",
      mark: { pending: "Pendiente", paid: "Pagado", accepted: "Aceptado", preparing: "Preparando", ready: "Listo para recoger", out_for_delivery: "En reparto", delivered: "Entregado", cancelled: "Cancelado", rejected: "Rechazado" },
      accept: "Aceptar",
      reject: "Rechazar",
      markPreparing: "Preparando",
      markReady: "Listo para recoger",
      markOut: "En reparto",
      updateEta: "Actualizar ETA",
      updateTime: "Actualizar Time",
      deliverTo: "Entregar a",
      pickupInStore: "Recoger en tienda",
      statusOpen: "Restaurante ABIERTO",
      statusClosed: "Restaurante CERRADO",
      openHint: "Estás aceptando pedidos.",
      closedHint: "Los clientes no pueden hacer pedidos.",
      openRestaurant: "Abrir restaurante",
      closeRestaurant: "Cerrar restaurante",
      deleteRestaurant: "Eliminar restaurante",
      deleteConfirmTitle: "¿Eliminar el restaurante?",
      deleteConfirmBody: "Esta operación eliminará permanentemente el RESTAURANTE, los PLATOS, los PEDIDOS y las TRANSACCIONES. Es IRREVERSIBLE.",
      deleteConfirmTypeHint: "Para confirmar, escribe el nombre del restaurante",
      deleteYes: "Sí, eliminar definitivamente",
      weeklyHours: "Horario semanal",
      weeklyHoursHint: "Fuera del horario, el sistema rechaza automáticamente los pedidos. Deja todo apagado para estar siempre abierto.",
      dayNames: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
      copyMonToAll: "Copiar Lun → todos",
      clearAll: "Vaciar todos",
      addSlot: "Añadir franja",
      closedDay: "Cerrado",
      loyalty: {
        title: "Puntos fidelidad",
        hint: "El cliente acumula puntos en cada pedido pagado y puede canjearlos al pagar.",
        on: "Activo",
        off: "Apagado",
        pointsPerEuro: "Puntos por cada 1 €",
        euroPerPoint: "€ por cada 1 punto",
        minRedeem: "Mín. puntos para canjear",
        preview: "Vista previa: {ppe} pt por cada 1 € · {ept} € de descuento por punto",
      },
      commission: {
        title: "Comisiones por liquidar",
        hint: "Pago automático al alcanzar € 50. También puedes pagar ahora en cualquier momento.",
        dueHint: "Has superado el umbral de € 50: liquida ahora las comisiones que debes a Renova.",
        orders: "pedidos en efectivo",
        payNow: "Pagar ahora",
      },
      waitingCustomer: "Esperando confirmación del cliente",
      refundManual: "reembolso manual",
      edit: "Editar",
      editDish: "Editar plato",
      cancel: "Cancelar",
      dishIngredients: "Ingredientes",
      dishAllergens: "Alérgenos",
      menuImportTitle: "Importar menú PDF",
      menuImportSub: "Sube un PDF de tu menú: la IA extrae nombre, descripción, ingredientes y alérgenos.",
      menuPickPdf: "Elegir PDF",
      dishesFound: "platos encontrados",
      menuImportConfirm: "Añadir todos",
      menuImportEmpty: "Ningún plato reconocido. Prueba con un PDF más claro.",
      uploadingPdf: "Subiendo PDF",
      aiProcessing: "IA procesando",
      savingDishes: "Guardando platos",
      aiHint: "Gemini está analizando el PDF, puede tardar 10-20s",
      extraGraceTitle: "Restaurante en prueba extra",
      extraGraceSub: "Tienes {d} días para pagar 3,00€/mes, o este restaurante será bloqueado (no eliminado).",
      extraExpiredTitle: "Restaurante bloqueado",
      extraExpiredSub: "El periodo de gracia de 3 días ha caducado. Paga 3,00€ para reactivarlo.",
      payExtraNow: "Pagar 3,00€ ahora",
      extraGraceBadge: "PRUEBA EXTRA",
      extraBlockedBadge: "BLOQUEADO",
      extraPaidBadge: "EXTRA OK",
      extraPaidUntil: "Pagado hasta",
      extraCreatedToastTitle: "¡Restaurante creado!",
      extraCreatedToastSub: "Tienes 3 días de prueba. Luego 3,00€/mes para mantenerlo activo.",
      lockedManually: "Bloqueado por el administrador",
      lockedOwnerSub: "Suscripción principal caducada",
      renewalSoonTitle: "Suscripción a punto de caducar",
      renewalSoonSub: "Caduca en {d} días. Renueva ahora para evitar interrupciones.",
      renew: "Renovar ahora",
      connectTitle: "Stripe Connect",
      connectSub: "Conecta tu cuenta Stripe para recibir los pagos directamente (Renova retiene el 6%).",
      connectBtn: "Conectar con Stripe",
      connectContinue: "Completar configuración",
      connectConnected: "Conectado",
      connectDisabledDemo: "Solo disponible en producción con clave Stripe real.",
      connectCharges: "Pagos",
      connectPayouts: "Transferencias",
      analyticsTitle: "Analíticas últimos {d} días",
      gmv: "GMV",
      commission: "Comisión 6%",
      ordersCount: "Pedidos",
      topRestaurants: "Top restaurantes"
    },
    storefront: {
      menu: "Menú",
      cart: "Carrito",
      empty: "El carrito está vacío",
      add: "Añadir",
      remove: "Quitar",
      subtotal: "Subtotal",
      loyaltyTitle: "Tus puntos",
      loyaltyDiscount: "Descuento puntos",
      loyaltyMinHint: "Mínimo {n} puntos para canjear",
      loyaltyNeedMore: "Necesitas al menos {n} puntos. Te faltan {x}.",
      pointsLabel: "Puntos",
      pointsShort: "pt",
      myOrdersLink: "Mis pedidos",
      googleSignup: "Registrarse con Google",
      tip: "Propina rider",
      tipHelp: "Deja una propina al rider (opcional)",
      urgency: "Entrega prioritaria",
      delivery: "Envío",
      pickup: "Recoger",
      pickupAt: "Recoger en",
      payOnDelivery: "Pagar en la entrega",
      payOnPickup: "Pagar al recoger",
      payOnArrivalHint: "Pagarás directamente al restaurante en efectivo.",
      choosePayment: "Elige cómo pagar",
      payNowStripe: "Pagar con tarjeta (Stripe)",
      notesLabel: "Notas del pedido (alergias, preferencias)",
      notesPlaceholder: "Ej. sin tomate, alérgico a lácteos, bien hecho...",
      methodInactive: "Método no activado por el restaurante",
      activeOrderTag: "Pedido en curso",
      activeOrdersCount: "{n} pedidos en curso",
      openBadge: "Abierto",
      closedBadge: "Cerrado",
      outsideHours: "Fuera de horario",
      closedNoOrders: "Restaurante cerrado",
      outsideHoursNoOrders: "Fuera del horario de apertura",
      trackOrder: "Seguir pedido",
      cashPayment: "PAGO A LA LLEGADA",
      discount: "Descuento",
      total: "Total",
      checkout: "Ir al pago",
      yourInfo: "Tus datos",
      loginRequired: "Inicia sesión con Google para pedir",
      loginRequiredSub: "Te pedimos iniciar sesión para enviar el pedido de forma segura.",
      loginGoogle: "Continuar con Google",
      name: "Nombre",
      phone: "Teléfono",
      address: "Dirección de entrega",
      notes: "Notas para el restaurante",
      payNow: "Pagar ahora",
      processing: "Procesando...",
      deliveryTime: "Entrega en ~{min} min",
      successTitle: "¡Pago recibido!",
      successDesc: "Gracias. El restaurante ha recibido tu pedido.",
      backHome: "Volver al restaurante",
      promoBanner: "Promo activa: -{p}%",
      loggedAs: "Pidiendo como",
      lockedTitle: "Restaurante no disponible temporalmente",
      lockedSub: "Este restaurante está bloqueado momentáneamente. Inténtalo más tarde."
    },
    admin: {
      title: "Renova 360 — Super Admin",
      kpiRestaurants: "Restaurantes activos",
      kpiCommission: "Comisión Renova (2%)",
      kpiSubs: "Ingresos suscripciones",
      kpiOrders: "Pedidos pagados",
      kpiGmv: "GMV total",
      kpiActiveSubs: "Cuentas activas",
      list: "Lista de restaurantes",
      orders: "Pedidos recientes",
      block: "Bloquear",
      unblock: "Desbloquear",
      suspend: "Suspender",
      unsuspend: "Reactivar",
      cancel: "Anular",
      restore: "Restaurar",
      delete: "Eliminar",
      suspended: "Suspendido",
      cancelled: "Anulado",
      suspendReasonPrompt: "Motivo de la suspensión (opcional):",
      deleteConfirmPrompt: "Para eliminar PERMANENTEMENTE el restaurante {n} (y todos sus datos: platos, pedidos, transacciones) escribe CANCELLA",
      open: "Abrir",
      accounting: "Contabilidad",
      ledger: "Movimientos",
      noLedger: "Sin movimientos",
      gmv: "GMV",
      commissionTotal: "Comisión 6%",
      commissionSettled: "Liquidada",
      commissionPending: "Pendiente cash",
      subscriptions: "Suscripciones",
      extraResto: "Extra rest.",
      revenueRenova: "Ingresos Renova"
    },
    myOrders: {
      tag: "PEDIDOS CLIENTE",
      title: "Mis pedidos",
      sub: "Sigue el estado de tus pedidos en tiempo real.",
      empty: "Aún no has hecho pedidos.",
      loginPrompt: "Inicia sesión con Google desde un restaurante para empezar.",
      back: "Volver",
      backToRestaurant: "Volver al restaurante",
      confirmDelivered: "Confirmar entrega",
      summary: "Resumen del pedido",
      rejectedTitle: "Pedido rechazado",
      refundManual: "El restaurante gestionará el reembolso manualmente en Stripe.",
      refundStatus: "Estado reembolso",
      pointsForOrder: "Puntos por este pedido",
      pointsTotal: "Total puntos",
      cashPay: "Efectivo",
      itemSingular: "plato",
      itemPlural: "platos"
    }
  }
};

const I18nContext = createContext({ lang: "it", t: STRINGS.it, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("foodgo_lang") || "it");
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("foodgo_lang", l);
  };
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const value = { lang, t: STRINGS[lang] || STRINGS.it, setLang };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() { return useContext(I18nContext); }

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
